//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ControlCentreApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    autoComplete_GetReferringDoctors(siteId: number | undefined): Observable<ReferringDoctorDTO[]> {
        let url_ = this.baseUrl + "/control-centre-api/v1/autocomplete/referring-doctors?";
        if (siteId === null)
            throw new Error("The parameter 'siteId' cannot be null.");
        else if (siteId !== undefined)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAutoComplete_GetReferringDoctors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutoComplete_GetReferringDoctors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReferringDoctorDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReferringDoctorDTO[]>;
        }));
    }

    protected processAutoComplete_GetReferringDoctors(response: HttpResponseBase): Observable<ReferringDoctorDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferringDoctorDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    autoComplete_GetPatientLocations(siteId: number | undefined): Observable<PatientLocationDTO[]> {
        let url_ = this.baseUrl + "/control-centre-api/v1/autocomplete/patient-locations?";
        if (siteId === null)
            throw new Error("The parameter 'siteId' cannot be null.");
        else if (siteId !== undefined)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAutoComplete_GetPatientLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutoComplete_GetPatientLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientLocationDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientLocationDTO[]>;
        }));
    }

    protected processAutoComplete_GetPatientLocations(response: HttpResponseBase): Observable<PatientLocationDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientLocationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bodyParts_GetBodyParts(): Observable<PaginatedResponseOfBodyPart> {
        let url_ = this.baseUrl + "/control-centre-api/v1/body-parts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBodyParts_GetBodyParts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBodyParts_GetBodyParts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfBodyPart>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfBodyPart>;
        }));
    }

    protected processBodyParts_GetBodyParts(response: HttpResponseBase): Observable<PaginatedResponseOfBodyPart> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfBodyPart.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clinicalDiscussions_Post(referralId: number): Observable<void> {
        let url_ = this.baseUrl + "/control-centre-api/v1/referrals/{referralId}/clinical-discussions";
        if (referralId === undefined || referralId === null)
            throw new Error("The parameter 'referralId' must be defined.");
        url_ = url_.replace("{referralId}", encodeURIComponent("" + referralId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClinicalDiscussions_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClinicalDiscussions_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClinicalDiscussions_Post(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clinicalDiscussions_Patch(referralId: number, clinicalDiscussionId: number, request: PatchClinicalDiscussion): Observable<void> {
        let url_ = this.baseUrl + "/control-centre-api/v1/referrals/{referralId}/clinical-discussions/{clinicalDiscussionId}";
        if (referralId === undefined || referralId === null)
            throw new Error("The parameter 'referralId' must be defined.");
        url_ = url_.replace("{referralId}", encodeURIComponent("" + referralId));
        if (clinicalDiscussionId === undefined || clinicalDiscussionId === null)
            throw new Error("The parameter 'clinicalDiscussionId' must be defined.");
        url_ = url_.replace("{clinicalDiscussionId}", encodeURIComponent("" + clinicalDiscussionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClinicalDiscussions_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClinicalDiscussions_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClinicalDiscussions_Patch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clinicalFeedback_GetClinicalFeedback(clinicalFeedbackId: string): Observable<GetClinicalFeedbackDto> {
        let url_ = this.baseUrl + "/control-centre-api/v1/clinical-feedback/feedback-items/{clinicalFeedbackId}";
        if (clinicalFeedbackId === undefined || clinicalFeedbackId === null)
            throw new Error("The parameter 'clinicalFeedbackId' must be defined.");
        url_ = url_.replace("{clinicalFeedbackId}", encodeURIComponent("" + clinicalFeedbackId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClinicalFeedback_GetClinicalFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClinicalFeedback_GetClinicalFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClinicalFeedbackDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClinicalFeedbackDto>;
        }));
    }

    protected processClinicalFeedback_GetClinicalFeedback(response: HttpResponseBase): Observable<GetClinicalFeedbackDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClinicalFeedbackDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Raises a new Clinical Feedback for an Order.
     */
    clinicalFeedback_PostClinicalFeedback(request: PostClinicalFeedbackRequest): Observable<PostClinicalFeedbackResponse> {
        let url_ = this.baseUrl + "/control-centre-api/v1/clinical-feedback/feedback-items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClinicalFeedback_PostClinicalFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClinicalFeedback_PostClinicalFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PostClinicalFeedbackResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PostClinicalFeedbackResponse>;
        }));
    }

    protected processClinicalFeedback_PostClinicalFeedback(response: HttpResponseBase): Observable<PostClinicalFeedbackResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PostClinicalFeedbackResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets Orders which have existing Clinical Feedback. This is the data used in the "default view".
     * @param orgCode (optional) 
     * @param siteIds (optional) 
     */
    clinicalFeedback_GetDefaultClinicalFeedback(orgCode: string | undefined, siteIds: number[] | undefined): Observable<PaginatedResponseOfGetClinicalFeedbackOrdersResponse> {
        let url_ = this.baseUrl + "/control-centre-api/v1/clinical-feedback/feedback-items?";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "orgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (siteIds === null)
            throw new Error("The parameter 'siteIds' cannot be null.");
        else if (siteIds !== undefined)
            siteIds && siteIds.forEach(item => { url_ += "siteIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClinicalFeedback_GetDefaultClinicalFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClinicalFeedback_GetDefaultClinicalFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfGetClinicalFeedbackOrdersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfGetClinicalFeedbackOrdersResponse>;
        }));
    }

    protected processClinicalFeedback_GetDefaultClinicalFeedback(response: HttpResponseBase): Observable<PaginatedResponseOfGetClinicalFeedbackOrdersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfGetClinicalFeedbackOrdersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets Orders, along with any existing Clinical Feedback, for the given search criteria.
     */
    clinicalFeedback_GetOrdersForClinicalFeedback(request: GetClinicalFeedbackOrdersRequest): Observable<PaginatedResponseOfGetClinicalFeedbackOrdersResponse> {
        let url_ = this.baseUrl + "/control-centre-api/v1/clinical-feedback/orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClinicalFeedback_GetOrdersForClinicalFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClinicalFeedback_GetOrdersForClinicalFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfGetClinicalFeedbackOrdersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfGetClinicalFeedbackOrdersResponse>;
        }));
    }

    protected processClinicalFeedback_GetOrdersForClinicalFeedback(response: HttpResponseBase): Observable<PaginatedResponseOfGetClinicalFeedbackOrdersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfGetClinicalFeedbackOrdersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clinicalFeedback_GetCustomerFeedbackDocumentUrl(clinicalFeedbackId: string): Observable<AwsS3ObjectPreSignedUrl> {
        let url_ = this.baseUrl + "/control-centre-api/v1/clinical-feedback/customer-feedback-documents/{clinicalFeedbackId}";
        if (clinicalFeedbackId === undefined || clinicalFeedbackId === null)
            throw new Error("The parameter 'clinicalFeedbackId' must be defined.");
        url_ = url_.replace("{clinicalFeedbackId}", encodeURIComponent("" + clinicalFeedbackId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClinicalFeedback_GetCustomerFeedbackDocumentUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClinicalFeedback_GetCustomerFeedbackDocumentUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AwsS3ObjectPreSignedUrl>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AwsS3ObjectPreSignedUrl>;
        }));
    }

    protected processClinicalFeedback_GetCustomerFeedbackDocumentUrl(response: HttpResponseBase): Observable<AwsS3ObjectPreSignedUrl> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AwsS3ObjectPreSignedUrl.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clinicalFeedback_GetEverlightResponseDocumentUrl(accessionNumber: string, documentId: string): Observable<AwsS3ObjectPreSignedUrl> {
        let url_ = this.baseUrl + "/control-centre-api/v1/clinical-feedback/everlight-response-documents/{accessionNumber}/{documentId}";
        if (accessionNumber === undefined || accessionNumber === null)
            throw new Error("The parameter 'accessionNumber' must be defined.");
        url_ = url_.replace("{accessionNumber}", encodeURIComponent("" + accessionNumber));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClinicalFeedback_GetEverlightResponseDocumentUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClinicalFeedback_GetEverlightResponseDocumentUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AwsS3ObjectPreSignedUrl>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AwsS3ObjectPreSignedUrl>;
        }));
    }

    protected processClinicalFeedback_GetEverlightResponseDocumentUrl(response: HttpResponseBase): Observable<AwsS3ObjectPreSignedUrl> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AwsS3ObjectPreSignedUrl.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Uploads an attachment document, to be included in a Clinical Feedback.
     * @param document (optional) 
     * @param accessionNumber (optional) 
     * @param documentId (optional) 
     */
    clinicalFeedback_UploadAttachments(document: FileParameter | null | undefined, accessionNumber: string | null | undefined, documentId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/control-centre-api/v1/clinical-feedback/attachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (document !== null && document !== undefined)
            content_.append("Document", document.data, document.fileName ? document.fileName : "Document");
        if (accessionNumber !== null && accessionNumber !== undefined)
            content_.append("AccessionNumber", accessionNumber.toString());
        if (documentId === null || documentId === undefined)
            throw new Error("The parameter 'documentId' cannot be null.");
        else
            content_.append("DocumentId", documentId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClinicalFeedback_UploadAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClinicalFeedback_UploadAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClinicalFeedback_UploadAttachments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an attachment document.
     */
    clinicalFeedback_DeleteAttachments(request: DeleteClinicalFeedbackAttachmentRequest): Observable<void> {
        let url_ = this.baseUrl + "/control-centre-api/v1/clinical-feedback/attachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClinicalFeedback_DeleteAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClinicalFeedback_DeleteAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClinicalFeedback_DeleteAttachments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    commonStudyDescriptions_GetCommonStudyDescriptions(): Observable<PaginatedResponseOfGetCommonStudyDescription> {
        let url_ = this.baseUrl + "/control-centre-api/v1/common-study-descriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCommonStudyDescriptions_GetCommonStudyDescriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommonStudyDescriptions_GetCommonStudyDescriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfGetCommonStudyDescription>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfGetCommonStudyDescription>;
        }));
    }

    protected processCommonStudyDescriptions_GetCommonStudyDescriptions(response: HttpResponseBase): Observable<PaginatedResponseOfGetCommonStudyDescription> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfGetCommonStudyDescription.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    demandManagement_GetSupersetToken(orgCode: string): Observable<SupersetTokenResponse> {
        let url_ = this.baseUrl + "/control-centre-api/v1/demand-management/superset-token/{orgCode}";
        if (orgCode === undefined || orgCode === null)
            throw new Error("The parameter 'orgCode' must be defined.");
        url_ = url_.replace("{orgCode}", encodeURIComponent("" + orgCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDemandManagement_GetSupersetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDemandManagement_GetSupersetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupersetTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupersetTokenResponse>;
        }));
    }

    protected processDemandManagement_GetSupersetToken(response: HttpResponseBase): Observable<SupersetTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupersetTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    integratedProtoReferrals_GetIntegratedProtoReferrals(orgCode: string | undefined, siteIds: number[] | null | undefined, searchString: string | null | undefined): Observable<PaginatedResponseOfGetIntegratedProtoReferral> {
        let url_ = this.baseUrl + "/control-centre-api/v1/integrated-proto-referrals?";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "OrgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (siteIds !== undefined && siteIds !== null)
            siteIds && siteIds.forEach(item => { url_ += "SiteIds=" + encodeURIComponent("" + item) + "&"; });
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIntegratedProtoReferrals_GetIntegratedProtoReferrals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIntegratedProtoReferrals_GetIntegratedProtoReferrals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfGetIntegratedProtoReferral>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfGetIntegratedProtoReferral>;
        }));
    }

    protected processIntegratedProtoReferrals_GetIntegratedProtoReferrals(response: HttpResponseBase): Observable<PaginatedResponseOfGetIntegratedProtoReferral> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfGetIntegratedProtoReferral.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    modalities_GetModalities(): Observable<PaginatedResponseOfModality> {
        let url_ = this.baseUrl + "/control-centre-api/v1/modalities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModalities_GetModalities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModalities_GetModalities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfModality>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfModality>;
        }));
    }

    protected processModalities_GetModalities(response: HttpResponseBase): Observable<PaginatedResponseOfModality> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfModality.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    priorReports_UploadFile(accessionNumber: string, file: FileParameter | undefined, priorAccessionNumber: string | null | undefined, priorModality: string | null | undefined, priorStudyDate: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/control-centre-api/v1/orders/{accessionNumber}/prior-reports";
        if (accessionNumber === undefined || accessionNumber === null)
            throw new Error("The parameter 'accessionNumber' must be defined.");
        url_ = url_.replace("{accessionNumber}", encodeURIComponent("" + accessionNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (priorAccessionNumber !== null && priorAccessionNumber !== undefined)
            content_.append("PriorAccessionNumber", priorAccessionNumber.toString());
        if (priorModality !== null && priorModality !== undefined)
            content_.append("PriorModality", priorModality.toString());
        if (priorStudyDate !== null && priorStudyDate !== undefined)
            content_.append("PriorStudyDate", priorStudyDate.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPriorReports_UploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPriorReports_UploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPriorReports_UploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    privateSettings_AllSites(): Observable<Site[]> {
        let url_ = this.baseUrl + "/control-centre-private-api/v1/settings/Sites";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrivateSettings_AllSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrivateSettings_AllSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Site[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Site[]>;
        }));
    }

    protected processPrivateSettings_AllSites(response: HttpResponseBase): Observable<Site[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Site.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    privateSettings_GetSite(id: number): Observable<Site> {
        let url_ = this.baseUrl + "/control-centre-private-api/v1/settings/Sites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrivateSettings_GetSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrivateSettings_GetSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Site>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Site>;
        }));
    }

    protected processPrivateSettings_GetSite(response: HttpResponseBase): Observable<Site> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Site.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    referralItems_PutReferralItems(referralId: number, putReferralItems: PutReferralItem[]): Observable<void> {
        let url_ = this.baseUrl + "/control-centre-api/v1/referrals/{referralId}/referral-items";
        if (referralId === undefined || referralId === null)
            throw new Error("The parameter 'referralId' must be defined.");
        url_ = url_.replace("{referralId}", encodeURIComponent("" + referralId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(putReferralItems);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReferralItems_PutReferralItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferralItems_PutReferralItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReferralItems_PutReferralItems(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    referralPriors_PostPriors(referralId: number, priors: PostReferralPrior[]): Observable<GetReferralPrior[]> {
        let url_ = this.baseUrl + "/control-centre-api/v1/referrals/{referralId}/priors";
        if (referralId === undefined || referralId === null)
            throw new Error("The parameter 'referralId' must be defined.");
        url_ = url_.replace("{referralId}", encodeURIComponent("" + referralId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(priors);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReferralPriors_PostPriors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferralPriors_PostPriors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReferralPrior[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReferralPrior[]>;
        }));
    }

    protected processReferralPriors_PostPriors(response: HttpResponseBase): Observable<GetReferralPrior[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(GetReferralPrior.fromJS(item));
            }
            else {
                result201 = <any>null;
            }
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    referralPriors_DeletePrior(referralId: number, priorId: number): Observable<void> {
        let url_ = this.baseUrl + "/control-centre-api/v1/referrals/{referralId}/priors/{priorId}";
        if (referralId === undefined || referralId === null)
            throw new Error("The parameter 'referralId' must be defined.");
        url_ = url_.replace("{referralId}", encodeURIComponent("" + referralId));
        if (priorId === undefined || priorId === null)
            throw new Error("The parameter 'priorId' must be defined.");
        url_ = url_.replace("{priorId}", encodeURIComponent("" + priorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReferralPriors_DeletePrior(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferralPriors_DeletePrior(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReferralPriors_DeletePrior(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    referrals_GetReferralList(orgCode: string | undefined, createdAtFrom: string | undefined, createdAtTo: string | null | undefined, patientExternalId: string | null | undefined, siteId: number[] | null | undefined, updatedAtFrom: string | null | undefined, updatedAtTo: string | null | undefined, status: ReferralStatus[] | null | undefined, urgency: UrgencyType[] | null | undefined, modalities: string[] | null | undefined): Observable<PaginatedResponseOfGetReferral> {
        let url_ = this.baseUrl + "/control-centre-api/v1/referrals?";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "OrgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (createdAtFrom === null)
            throw new Error("The parameter 'createdAtFrom' cannot be null.");
        else if (createdAtFrom !== undefined)
            url_ += "CreatedAtFrom=" + encodeURIComponent("" + createdAtFrom) + "&";
        if (createdAtTo !== undefined && createdAtTo !== null)
            url_ += "CreatedAtTo=" + encodeURIComponent("" + createdAtTo) + "&";
        if (patientExternalId !== undefined && patientExternalId !== null)
            url_ += "PatientExternalId=" + encodeURIComponent("" + patientExternalId) + "&";
        if (siteId !== undefined && siteId !== null)
            siteId && siteId.forEach(item => { url_ += "SiteId=" + encodeURIComponent("" + item) + "&"; });
        if (updatedAtFrom !== undefined && updatedAtFrom !== null)
            url_ += "UpdatedAtFrom=" + encodeURIComponent("" + updatedAtFrom) + "&";
        if (updatedAtTo !== undefined && updatedAtTo !== null)
            url_ += "UpdatedAtTo=" + encodeURIComponent("" + updatedAtTo) + "&";
        if (status !== undefined && status !== null)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (urgency !== undefined && urgency !== null)
            urgency && urgency.forEach(item => { url_ += "Urgency=" + encodeURIComponent("" + item) + "&"; });
        if (modalities !== undefined && modalities !== null)
            modalities && modalities.forEach(item => { url_ += "Modalities=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReferrals_GetReferralList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferrals_GetReferralList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResponseOfGetReferral>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResponseOfGetReferral>;
        }));
    }

    protected processReferrals_GetReferralList(response: HttpResponseBase): Observable<PaginatedResponseOfGetReferral> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResponseOfGetReferral.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    referrals_PostReferral(request: PostReferral): Observable<void> {
        let url_ = this.baseUrl + "/control-centre-api/v1/referrals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReferrals_PostReferral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferrals_PostReferral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReferrals_PostReferral(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    referrals_GetReferral(id: number): Observable<GetReferralDetails> {
        let url_ = this.baseUrl + "/control-centre-api/v1/referrals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReferrals_GetReferral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferrals_GetReferral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReferralDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReferralDetails>;
        }));
    }

    protected processReferrals_GetReferral(response: HttpResponseBase): Observable<GetReferralDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReferralDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    referrals_PatchReferral(id: number, request: PatchReferral): Observable<void> {
        let url_ = this.baseUrl + "/control-centre-api/v1/referrals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReferrals_PatchReferral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferrals_PatchReferral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReferrals_PatchReferral(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    referrals_AcknowledgeReferral(id: number, request: AcknowledgeReferralRequest): Observable<void> {
        let url_ = this.baseUrl + "/control-centre-api/v1/referrals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReferrals_AcknowledgeReferral(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferrals_AcknowledgeReferral(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReferrals_AcknowledgeReferral(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    referrals_GetReferralLinkingDetails(accessionNumber: string): Observable<GetReferralLinkingDetails> {
        let url_ = this.baseUrl + "/control-centre-api/v1/referrals/linked-referral/{accessionNumber}";
        if (accessionNumber === undefined || accessionNumber === null)
            throw new Error("The parameter 'accessionNumber' must be defined.");
        url_ = url_.replace("{accessionNumber}", encodeURIComponent("" + accessionNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReferrals_GetReferralLinkingDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferrals_GetReferralLinkingDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReferralLinkingDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReferralLinkingDetails>;
        }));
    }

    protected processReferrals_GetReferralLinkingDetails(response: HttpResponseBase): Observable<GetReferralLinkingDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReferralLinkingDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    remoteOrder_Add(remoteOrderRequest: RemoteOrderRequest): Observable<string[]> {
        let url_ = this.baseUrl + "/control-centre-api/v1/remote-orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(remoteOrderRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoteOrder_Add(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoteOrder_Add(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processRemoteOrder_Add(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scannedDocuments_UploadFile(accessionNumber: string, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/control-centre-api/v1/orders/{accessionNumber}/scanned-documents";
        if (accessionNumber === undefined || accessionNumber === null)
            throw new Error("The parameter 'accessionNumber' must be defined.");
        url_ = url_.replace("{accessionNumber}", encodeURIComponent("" + accessionNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScannedDocuments_UploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScannedDocuments_UploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScannedDocuments_UploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scannedDocuments_GetScannedDocumentUrl(accessionNumber: string, documentName: string): Observable<string> {
        let url_ = this.baseUrl + "/control-centre-api/v1/orders/{accessionNumber}/scanned-documents/{documentName}";
        if (accessionNumber === undefined || accessionNumber === null)
            throw new Error("The parameter 'accessionNumber' must be defined.");
        url_ = url_.replace("{accessionNumber}", encodeURIComponent("" + accessionNumber));
        if (documentName === undefined || documentName === null)
            throw new Error("The parameter 'documentName' must be defined.");
        url_ = url_.replace("{documentName}", encodeURIComponent("" + documentName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScannedDocuments_GetScannedDocumentUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScannedDocuments_GetScannedDocumentUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processScannedDocuments_GetScannedDocumentUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    settings_Clients(orgCode: string, includeSettings: boolean | undefined): Observable<GetClient> {
        let url_ = this.baseUrl + "/control-centre-api/v1/settings/Clients/{orgCode}?";
        if (orgCode === undefined || orgCode === null)
            throw new Error("The parameter 'orgCode' must be defined.");
        url_ = url_.replace("{orgCode}", encodeURIComponent("" + orgCode));
        if (includeSettings === null)
            throw new Error("The parameter 'includeSettings' cannot be null.");
        else if (includeSettings !== undefined)
            url_ += "includeSettings=" + encodeURIComponent("" + includeSettings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSettings_Clients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSettings_Clients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClient>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClient>;
        }));
    }

    protected processSettings_Clients(response: HttpResponseBase): Observable<GetClient> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClient.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    settings_Sites(orgCode: string): Observable<Site[]> {
        let url_ = this.baseUrl + "/control-centre-api/v1/settings/Sites/{orgCode}";
        if (orgCode === undefined || orgCode === null)
            throw new Error("The parameter 'orgCode' must be defined.");
        url_ = url_.replace("{orgCode}", encodeURIComponent("" + orgCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSettings_Sites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSettings_Sites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Site[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Site[]>;
        }));
    }

    protected processSettings_Sites(response: HttpResponseBase): Observable<Site[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Site.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    worklistItems_Query(orgCode: string | undefined, siteId: (string | undefined)[] | null | undefined, from: string | null | undefined, to: string | null | undefined, patientId: string | null | undefined, statuses: StatusType[] | null | undefined, urgencies: UrgencyType[] | null | undefined, includeLinkedReferral: boolean | undefined, includeUnlinkedOrders: boolean | undefined, modalities: string[] | null | undefined): Observable<WorklistItemDto[]> {
        let url_ = this.baseUrl + "/control-centre-api/v1/worklist-items?";
        if (orgCode === null)
            throw new Error("The parameter 'orgCode' cannot be null.");
        else if (orgCode !== undefined)
            url_ += "OrgCode=" + encodeURIComponent("" + orgCode) + "&";
        if (siteId !== undefined && siteId !== null)
            siteId && siteId.forEach(item => { url_ += "SiteId=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (patientId !== undefined && patientId !== null)
            url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (urgencies !== undefined && urgencies !== null)
            urgencies && urgencies.forEach(item => { url_ += "Urgencies=" + encodeURIComponent("" + item) + "&"; });
        if (includeLinkedReferral === null)
            throw new Error("The parameter 'includeLinkedReferral' cannot be null.");
        else if (includeLinkedReferral !== undefined)
            url_ += "IncludeLinkedReferral=" + encodeURIComponent("" + includeLinkedReferral) + "&";
        if (includeUnlinkedOrders === null)
            throw new Error("The parameter 'includeUnlinkedOrders' cannot be null.");
        else if (includeUnlinkedOrders !== undefined)
            url_ += "IncludeUnlinkedOrders=" + encodeURIComponent("" + includeUnlinkedOrders) + "&";
        if (modalities !== undefined && modalities !== null)
            modalities && modalities.forEach(item => { url_ += "Modalities=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorklistItems_Query(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorklistItems_Query(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorklistItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorklistItemDto[]>;
        }));
    }

    protected processWorklistItems_Query(response: HttpResponseBase): Observable<WorklistItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorklistItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    worklistItems_GetUnlinkedOrder(id: string): Observable<WorklistItemDetailsDto> {
        let url_ = this.baseUrl + "/control-centre-api/v1/worklist-items/unlinked-order/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorklistItems_GetUnlinkedOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorklistItems_GetUnlinkedOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorklistItemDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorklistItemDetailsDto>;
        }));
    }

    protected processWorklistItems_GetUnlinkedOrder(response: HttpResponseBase): Observable<WorklistItemDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorklistItemDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    worklistItems_GetOrder(id: string): Observable<WorklistItemDetailsDto> {
        let url_ = this.baseUrl + "/control-centre-api/v1/worklist-items/order/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorklistItems_GetOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorklistItems_GetOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorklistItemDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorklistItemDetailsDto>;
        }));
    }

    protected processWorklistItems_GetOrder(response: HttpResponseBase): Observable<WorklistItemDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorklistItemDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    worklistItems_PatchOrder(id: string, request: PatchOrderRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/control-centre-api/v1/worklist-items/order/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorklistItems_PatchOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorklistItems_PatchOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processWorklistItems_PatchOrder(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    worklistItems_PatchProcedure(orderId: string, procedureId: number, request: PatchProcedureRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/control-centre-api/v1/worklist-items/order/{orderId}/procedure/{procedureId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (procedureId === undefined || procedureId === null)
            throw new Error("The parameter 'procedureId' must be defined.");
        url_ = url_.replace("{procedureId}", encodeURIComponent("" + procedureId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorklistItems_PatchProcedure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorklistItems_PatchProcedure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processWorklistItems_PatchProcedure(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    worklistItems_PostOrderPrior(orderId: string, request: PostPriorRequest): Observable<PriorDto> {
        let url_ = this.baseUrl + "/control-centre-api/v1/worklist-items/order/{orderId}/priors";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorklistItems_PostOrderPrior(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorklistItems_PostOrderPrior(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriorDto>;
        }));
    }

    protected processWorklistItems_PostOrderPrior(response: HttpResponseBase): Observable<PriorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    worklistItems_PatchOrderPrior(orderId: string, priorId: number, request: PatchPriorRequest): Observable<PriorDto> {
        let url_ = this.baseUrl + "/control-centre-api/v1/worklist-items/order/{orderId}/priors/{priorId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (priorId === undefined || priorId === null)
            throw new Error("The parameter 'priorId' must be defined.");
        url_ = url_.replace("{priorId}", encodeURIComponent("" + priorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorklistItems_PatchOrderPrior(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorklistItems_PatchOrderPrior(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriorDto>;
        }));
    }

    protected processWorklistItems_PatchOrderPrior(response: HttpResponseBase): Observable<PriorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    worklistItems_DeleteOrderPrior(orderId: string, priorId: number, radiographerName: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/control-centre-api/v1/worklist-items/order/{orderId}/priors/{priorId}?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (priorId === undefined || priorId === null)
            throw new Error("The parameter 'priorId' must be defined.");
        url_ = url_.replace("{priorId}", encodeURIComponent("" + priorId));
        if (radiographerName !== undefined && radiographerName !== null)
            url_ += "radiographerName=" + encodeURIComponent("" + radiographerName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorklistItems_DeleteOrderPrior(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorklistItems_DeleteOrderPrior(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWorklistItems_DeleteOrderPrior(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ReferringDoctorDTO implements IReferringDoctorDTO {
    name?: string | undefined;
    countryCode?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    expiry?: number | undefined;

    constructor(data?: IReferringDoctorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.countryCode = _data["countryCode"];
            this.phone = _data["phone"];
            this.extension = _data["extension"];
            this.expiry = _data["expiry"];
        }
    }

    static fromJS(data: any): ReferringDoctorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ReferringDoctorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["countryCode"] = this.countryCode;
        data["phone"] = this.phone;
        data["extension"] = this.extension;
        data["expiry"] = this.expiry;
        return data;
    }
}

export interface IReferringDoctorDTO {
    name?: string | undefined;
    countryCode?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    expiry?: number | undefined;
}

export class PatientLocationDTO implements IPatientLocationDTO {
    location?: string | undefined;

    constructor(data?: IPatientLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): PatientLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PatientLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        return data;
    }
}

export interface IPatientLocationDTO {
    location?: string | undefined;
}

export class PaginatedResponseOfBodyPart implements IPaginatedResponseOfBodyPart {
    items?: BodyPart[];
    count?: number;
    hasMore?: boolean;

    constructor(data?: IPaginatedResponseOfBodyPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BodyPart.fromJS(item));
            }
            this.count = _data["count"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfBodyPart {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfBodyPart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["count"] = this.count;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IPaginatedResponseOfBodyPart {
    items?: BodyPart[];
    count?: number;
    hasMore?: boolean;
}

export class BodyPart implements IBodyPart {
    id?: number;
    name!: string;

    constructor(data?: IBodyPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BodyPart {
        data = typeof data === 'object' ? data : {};
        let result = new BodyPart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBodyPart {
    id?: number;
    name: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class PatchClinicalDiscussion implements IPatchClinicalDiscussion {
    rowVersion?: string;
    status?: ClinicalDiscussionStatus | undefined;

    constructor(data?: IPatchClinicalDiscussion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowVersion = _data["rowVersion"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PatchClinicalDiscussion {
        data = typeof data === 'object' ? data : {};
        let result = new PatchClinicalDiscussion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowVersion"] = this.rowVersion;
        data["status"] = this.status;
        return data;
    }
}

export interface IPatchClinicalDiscussion {
    rowVersion?: string;
    status?: ClinicalDiscussionStatus | undefined;
}

export enum ClinicalDiscussionStatus {
    Unknown = 0,
    Open = 1,
    Completed = 2,
    Cancelled = 3,
}

export class GetClinicalFeedbackDto implements IGetClinicalFeedbackDto {
    id?: string;
    orgCode?: string;
    siteId?: number | undefined;
    accessionNumber?: string;
    status?: FeedbackStatus;
    feedbackType?: FeedbackType;
    clinicalFeedbackId?: string;
    feedbackJson?: string;
    everlightResponses?: GetEverlightResponse[];
    rowVersion?: string;

    constructor(data?: IGetClinicalFeedbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orgCode = _data["orgCode"];
            this.siteId = _data["siteId"];
            this.accessionNumber = _data["accessionNumber"];
            this.status = _data["status"];
            this.feedbackType = _data["feedbackType"];
            this.clinicalFeedbackId = _data["clinicalFeedbackId"];
            this.feedbackJson = _data["feedbackJson"];
            if (Array.isArray(_data["everlightResponses"])) {
                this.everlightResponses = [] as any;
                for (let item of _data["everlightResponses"])
                    this.everlightResponses!.push(GetEverlightResponse.fromJS(item));
            }
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): GetClinicalFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetClinicalFeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orgCode"] = this.orgCode;
        data["siteId"] = this.siteId;
        data["accessionNumber"] = this.accessionNumber;
        data["status"] = this.status;
        data["feedbackType"] = this.feedbackType;
        data["clinicalFeedbackId"] = this.clinicalFeedbackId;
        data["feedbackJson"] = this.feedbackJson;
        if (Array.isArray(this.everlightResponses)) {
            data["everlightResponses"] = [];
            for (let item of this.everlightResponses)
                data["everlightResponses"].push(item ? item.toJSON() : <any>undefined);
        }
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IGetClinicalFeedbackDto {
    id?: string;
    orgCode?: string;
    siteId?: number | undefined;
    accessionNumber?: string;
    status?: FeedbackStatus;
    feedbackType?: FeedbackType;
    clinicalFeedbackId?: string;
    feedbackJson?: string;
    everlightResponses?: GetEverlightResponse[];
    rowVersion?: string;
}

export enum FeedbackStatus {
    New = "New",
    InProgress = "InProgress",
    ClientInputRequired = "ClientInputRequired",
    Complete = "Complete",
    Cancelled = "Cancelled",
}

export enum FeedbackType {
    Unknown = "Unknown",
    ClinicalFeedback = "ClinicalFeedback",
    AdvisedSeriousIncident = "AdvisedSeriousIncident",
}

export class GetEverlightResponse implements IGetEverlightResponse {
    originalFileName!: string;
    documentId!: string;

    constructor(data?: IGetEverlightResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalFileName = _data["originalFileName"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): GetEverlightResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEverlightResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalFileName"] = this.originalFileName;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IGetEverlightResponse {
    originalFileName: string;
    documentId: string;
}

export class PostClinicalFeedbackResponse implements IPostClinicalFeedbackResponse {
    clinicalFeedbackId?: string;

    constructor(data?: IPostClinicalFeedbackResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clinicalFeedbackId = _data["clinicalFeedbackId"];
        }
    }

    static fromJS(data: any): PostClinicalFeedbackResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PostClinicalFeedbackResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicalFeedbackId"] = this.clinicalFeedbackId;
        return data;
    }
}

export interface IPostClinicalFeedbackResponse {
    clinicalFeedbackId?: string;
}

export class PostClinicalFeedbackRequest implements IPostClinicalFeedbackRequest {
    accessionNumber?: string;
    feedbackType?: FeedbackType;
    feedbackJson?: string;

    constructor(data?: IPostClinicalFeedbackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessionNumber = _data["accessionNumber"];
            this.feedbackType = _data["feedbackType"];
            this.feedbackJson = _data["feedbackJson"];
        }
    }

    static fromJS(data: any): PostClinicalFeedbackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostClinicalFeedbackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessionNumber"] = this.accessionNumber;
        data["feedbackType"] = this.feedbackType;
        data["feedbackJson"] = this.feedbackJson;
        return data;
    }
}

export interface IPostClinicalFeedbackRequest {
    accessionNumber?: string;
    feedbackType?: FeedbackType;
    feedbackJson?: string;
}

export class PaginatedResponseOfGetClinicalFeedbackOrdersResponse implements IPaginatedResponseOfGetClinicalFeedbackOrdersResponse {
    items?: GetClinicalFeedbackOrdersResponse[];
    count?: number;
    hasMore?: boolean;

    constructor(data?: IPaginatedResponseOfGetClinicalFeedbackOrdersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetClinicalFeedbackOrdersResponse.fromJS(item));
            }
            this.count = _data["count"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfGetClinicalFeedbackOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfGetClinicalFeedbackOrdersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["count"] = this.count;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IPaginatedResponseOfGetClinicalFeedbackOrdersResponse {
    items?: GetClinicalFeedbackOrdersResponse[];
    count?: number;
    hasMore?: boolean;
}

export class GetClinicalFeedbackOrdersResponse implements IGetClinicalFeedbackOrdersResponse {
    orgCode?: string;
    region?: Region;
    patientId?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientDateOfBirth?: string | undefined;
    accessionNumber?: string | undefined;
    trimmedAccessionNumber?: string | undefined;
    urgency?: string | undefined;
    feedbackStatus?: FeedbackStatus | undefined;
    feedbackType?: FeedbackType | undefined;
    feedbackSeriousIncidentType?: SeriousIncidentType | undefined;
    clinicalFeedbackId?: string | undefined;
    feedbackCreatedAt?: string | undefined;
    studyDateTime?: string | undefined;
    modality?: string | undefined;
    radiologist?: string | undefined;
    studyType?: string | undefined;
    everlightResponses?: GetDocument[];

    constructor(data?: IGetClinicalFeedbackOrdersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgCode = _data["orgCode"];
            this.region = _data["region"];
            this.patientId = _data["patientId"];
            this.patientFirstName = _data["patientFirstName"];
            this.patientLastName = _data["patientLastName"];
            this.patientDateOfBirth = _data["patientDateOfBirth"];
            this.accessionNumber = _data["accessionNumber"];
            this.trimmedAccessionNumber = _data["trimmedAccessionNumber"];
            this.urgency = _data["urgency"];
            this.feedbackStatus = _data["feedbackStatus"];
            this.feedbackType = _data["feedbackType"];
            this.feedbackSeriousIncidentType = _data["feedbackSeriousIncidentType"];
            this.clinicalFeedbackId = _data["clinicalFeedbackId"];
            this.feedbackCreatedAt = _data["feedbackCreatedAt"];
            this.studyDateTime = _data["studyDateTime"];
            this.modality = _data["modality"];
            this.radiologist = _data["radiologist"];
            this.studyType = _data["studyType"];
            if (Array.isArray(_data["everlightResponses"])) {
                this.everlightResponses = [] as any;
                for (let item of _data["everlightResponses"])
                    this.everlightResponses!.push(GetDocument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetClinicalFeedbackOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetClinicalFeedbackOrdersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgCode"] = this.orgCode;
        data["region"] = this.region;
        data["patientId"] = this.patientId;
        data["patientFirstName"] = this.patientFirstName;
        data["patientLastName"] = this.patientLastName;
        data["patientDateOfBirth"] = this.patientDateOfBirth;
        data["accessionNumber"] = this.accessionNumber;
        data["trimmedAccessionNumber"] = this.trimmedAccessionNumber;
        data["urgency"] = this.urgency;
        data["feedbackStatus"] = this.feedbackStatus;
        data["feedbackType"] = this.feedbackType;
        data["feedbackSeriousIncidentType"] = this.feedbackSeriousIncidentType;
        data["clinicalFeedbackId"] = this.clinicalFeedbackId;
        data["feedbackCreatedAt"] = this.feedbackCreatedAt;
        data["studyDateTime"] = this.studyDateTime;
        data["modality"] = this.modality;
        data["radiologist"] = this.radiologist;
        data["studyType"] = this.studyType;
        if (Array.isArray(this.everlightResponses)) {
            data["everlightResponses"] = [];
            for (let item of this.everlightResponses)
                data["everlightResponses"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IGetClinicalFeedbackOrdersResponse {
    orgCode?: string;
    region?: Region;
    patientId?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientDateOfBirth?: string | undefined;
    accessionNumber?: string | undefined;
    trimmedAccessionNumber?: string | undefined;
    urgency?: string | undefined;
    feedbackStatus?: FeedbackStatus | undefined;
    feedbackType?: FeedbackType | undefined;
    feedbackSeriousIncidentType?: SeriousIncidentType | undefined;
    clinicalFeedbackId?: string | undefined;
    feedbackCreatedAt?: string | undefined;
    studyDateTime?: string | undefined;
    modality?: string | undefined;
    radiologist?: string | undefined;
    studyType?: string | undefined;
    everlightResponses?: GetDocument[];
}

export enum Region {
    Unknown = "Unknown",
    Uki = "Uki",
    Anz = "Anz",
}

export enum SeriousIncidentType {
    Unknown = "Unknown",
    ConfirmedSeriousIncident = "ConfirmedSeriousIncident",
    AimsIms = "AimsIms",
    RegulatoryInvestigations = "RegulatoryInvestigations",
    DutyOfCandour = "DutyOfCandour",
    Other = "Other",
}

export class GetDocument implements IGetDocument {
    documentId?: string;
    originalFileName?: string;

    constructor(data?: IGetDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.originalFileName = _data["originalFileName"];
        }
    }

    static fromJS(data: any): GetDocument {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["originalFileName"] = this.originalFileName;
        return data;
    }
}

export interface IGetDocument {
    documentId?: string;
    originalFileName?: string;
}

export class GetClinicalFeedbackOrdersRequest implements IGetClinicalFeedbackOrdersRequest {
    orgCode?: string;
    siteIds?: number[];
    accessionNumber?: string | undefined;
    patientMrn?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientDateOfBirth?: string | undefined;
    studyDateTime?: string | undefined;

    constructor(data?: IGetClinicalFeedbackOrdersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgCode = _data["orgCode"];
            if (Array.isArray(_data["siteIds"])) {
                this.siteIds = [] as any;
                for (let item of _data["siteIds"])
                    this.siteIds!.push(item);
            }
            this.accessionNumber = _data["accessionNumber"];
            this.patientMrn = _data["patientMrn"];
            this.patientFirstName = _data["patientFirstName"];
            this.patientLastName = _data["patientLastName"];
            this.patientDateOfBirth = _data["patientDateOfBirth"];
            this.studyDateTime = _data["studyDateTime"];
        }
    }

    static fromJS(data: any): GetClinicalFeedbackOrdersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetClinicalFeedbackOrdersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgCode"] = this.orgCode;
        if (Array.isArray(this.siteIds)) {
            data["siteIds"] = [];
            for (let item of this.siteIds)
                data["siteIds"].push(item);
        }
        data["accessionNumber"] = this.accessionNumber;
        data["patientMrn"] = this.patientMrn;
        data["patientFirstName"] = this.patientFirstName;
        data["patientLastName"] = this.patientLastName;
        data["patientDateOfBirth"] = this.patientDateOfBirth;
        data["studyDateTime"] = this.studyDateTime;
        return data;
    }
}

export interface IGetClinicalFeedbackOrdersRequest {
    orgCode?: string;
    siteIds?: number[];
    accessionNumber?: string | undefined;
    patientMrn?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientDateOfBirth?: string | undefined;
    studyDateTime?: string | undefined;
}

export class AwsS3ObjectPreSignedUrl implements IAwsS3ObjectPreSignedUrl {
    url!: string;
    contentType!: string;
    key!: string;
    expires!: string;

    constructor(data?: IAwsS3ObjectPreSignedUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.contentType = _data["contentType"];
            this.key = _data["key"];
            this.expires = _data["expires"];
        }
    }

    static fromJS(data: any): AwsS3ObjectPreSignedUrl {
        data = typeof data === 'object' ? data : {};
        let result = new AwsS3ObjectPreSignedUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["contentType"] = this.contentType;
        data["key"] = this.key;
        data["expires"] = this.expires;
        return data;
    }
}

export interface IAwsS3ObjectPreSignedUrl {
    url: string;
    contentType: string;
    key: string;
    expires: string;
}

export class DeleteClinicalFeedbackAttachmentRequest implements IDeleteClinicalFeedbackAttachmentRequest {
    accessionNumber?: string;
    documentId?: string;

    constructor(data?: IDeleteClinicalFeedbackAttachmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessionNumber = _data["accessionNumber"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): DeleteClinicalFeedbackAttachmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteClinicalFeedbackAttachmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessionNumber"] = this.accessionNumber;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IDeleteClinicalFeedbackAttachmentRequest {
    accessionNumber?: string;
    documentId?: string;
}

export class PaginatedResponseOfGetCommonStudyDescription implements IPaginatedResponseOfGetCommonStudyDescription {
    items?: GetCommonStudyDescription[];
    count?: number;
    hasMore?: boolean;

    constructor(data?: IPaginatedResponseOfGetCommonStudyDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCommonStudyDescription.fromJS(item));
            }
            this.count = _data["count"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfGetCommonStudyDescription {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfGetCommonStudyDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["count"] = this.count;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IPaginatedResponseOfGetCommonStudyDescription {
    items?: GetCommonStudyDescription[];
    count?: number;
    hasMore?: boolean;
}

export class GetCommonStudyDescription implements IGetCommonStudyDescription {
    studyId?: number;
    modality?: string | undefined;
    description?: string | undefined;

    constructor(data?: IGetCommonStudyDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.modality = _data["modality"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetCommonStudyDescription {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommonStudyDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["modality"] = this.modality;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetCommonStudyDescription {
    studyId?: number;
    modality?: string | undefined;
    description?: string | undefined;
}

export class SupersetTokenResponse implements ISupersetTokenResponse {
    guestToken?: string;
    orgRestriction?: string;
    dashboardId?: string;
    expiry?: string;

    constructor(data?: ISupersetTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guestToken = _data["guestToken"];
            this.orgRestriction = _data["orgRestriction"];
            this.dashboardId = _data["dashboardId"];
            this.expiry = _data["expiry"];
        }
    }

    static fromJS(data: any): SupersetTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupersetTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestToken"] = this.guestToken;
        data["orgRestriction"] = this.orgRestriction;
        data["dashboardId"] = this.dashboardId;
        data["expiry"] = this.expiry;
        return data;
    }
}

export interface ISupersetTokenResponse {
    guestToken?: string;
    orgRestriction?: string;
    dashboardId?: string;
    expiry?: string;
}

export class PaginatedResponseOfGetIntegratedProtoReferral implements IPaginatedResponseOfGetIntegratedProtoReferral {
    items?: GetIntegratedProtoReferral[];
    count?: number;
    hasMore?: boolean;

    constructor(data?: IPaginatedResponseOfGetIntegratedProtoReferral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetIntegratedProtoReferral.fromJS(item));
            }
            this.count = _data["count"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfGetIntegratedProtoReferral {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfGetIntegratedProtoReferral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["count"] = this.count;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IPaginatedResponseOfGetIntegratedProtoReferral {
    items?: GetIntegratedProtoReferral[];
    count?: number;
    hasMore?: boolean;
}

export class GetIntegratedProtoReferral implements IGetIntegratedProtoReferral {
    orgCode?: string;
    siteId?: number;
    patientExternalId?: string;
    firstName?: string;
    lastName?: string;
    regionsForScanning?: GetIntegratedProtoReferralItem[];
    sex?: string | undefined;
    dateOfBirth?: string | undefined;
    location?: string | undefined;
    clinicalHistory?: string | undefined;
    differentialDiagnosis?: string | undefined;
    pregnancy?: PregnancyStatus | undefined;
    egfrResult?: string | undefined;
    referrerName?: string | undefined;
    referrerPhone?: string | undefined;
    contrastAllergy?: ContrastAllergyType | undefined;
    siteName?: string | undefined;

    constructor(data?: IGetIntegratedProtoReferral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgCode = _data["orgCode"];
            this.siteId = _data["siteId"];
            this.patientExternalId = _data["patientExternalId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["regionsForScanning"])) {
                this.regionsForScanning = [] as any;
                for (let item of _data["regionsForScanning"])
                    this.regionsForScanning!.push(GetIntegratedProtoReferralItem.fromJS(item));
            }
            this.sex = _data["sex"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.location = _data["location"];
            this.clinicalHistory = _data["clinicalHistory"];
            this.differentialDiagnosis = _data["differentialDiagnosis"];
            this.pregnancy = _data["pregnancy"];
            this.egfrResult = _data["egfrResult"];
            this.referrerName = _data["referrerName"];
            this.referrerPhone = _data["referrerPhone"];
            this.contrastAllergy = _data["contrastAllergy"];
            this.siteName = _data["siteName"];
        }
    }

    static fromJS(data: any): GetIntegratedProtoReferral {
        data = typeof data === 'object' ? data : {};
        let result = new GetIntegratedProtoReferral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgCode"] = this.orgCode;
        data["siteId"] = this.siteId;
        data["patientExternalId"] = this.patientExternalId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.regionsForScanning)) {
            data["regionsForScanning"] = [];
            for (let item of this.regionsForScanning)
                data["regionsForScanning"].push(item ? item.toJSON() : <any>undefined);
        }
        data["sex"] = this.sex;
        data["dateOfBirth"] = this.dateOfBirth;
        data["location"] = this.location;
        data["clinicalHistory"] = this.clinicalHistory;
        data["differentialDiagnosis"] = this.differentialDiagnosis;
        data["pregnancy"] = this.pregnancy;
        data["egfrResult"] = this.egfrResult;
        data["referrerName"] = this.referrerName;
        data["referrerPhone"] = this.referrerPhone;
        data["contrastAllergy"] = this.contrastAllergy;
        data["siteName"] = this.siteName;
        return data;
    }
}

export interface IGetIntegratedProtoReferral {
    orgCode?: string;
    siteId?: number;
    patientExternalId?: string;
    firstName?: string;
    lastName?: string;
    regionsForScanning?: GetIntegratedProtoReferralItem[];
    sex?: string | undefined;
    dateOfBirth?: string | undefined;
    location?: string | undefined;
    clinicalHistory?: string | undefined;
    differentialDiagnosis?: string | undefined;
    pregnancy?: PregnancyStatus | undefined;
    egfrResult?: string | undefined;
    referrerName?: string | undefined;
    referrerPhone?: string | undefined;
    contrastAllergy?: ContrastAllergyType | undefined;
    siteName?: string | undefined;
}

export class GetIntegratedProtoReferralItem implements IGetIntegratedProtoReferralItem {
    modality?: string | undefined;
    bodyPart?: string | undefined;
    phaseOfContrast?: string | undefined;

    constructor(data?: IGetIntegratedProtoReferralItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modality = _data["modality"];
            this.bodyPart = _data["bodyPart"];
            this.phaseOfContrast = _data["phaseOfContrast"];
        }
    }

    static fromJS(data: any): GetIntegratedProtoReferralItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetIntegratedProtoReferralItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modality"] = this.modality;
        data["bodyPart"] = this.bodyPart;
        data["phaseOfContrast"] = this.phaseOfContrast;
        return data;
    }
}

export interface IGetIntegratedProtoReferralItem {
    modality?: string | undefined;
    bodyPart?: string | undefined;
    phaseOfContrast?: string | undefined;
}

export enum PregnancyStatus {
    Unknown = "Unknown",
    No = "No",
    YesScanConsent = "YesScanConsent",
}

export enum ContrastAllergyType {
    Unknown = "Unknown",
    No = "No",
    Yes = "Yes",
}

export class PaginatedResponseOfModality implements IPaginatedResponseOfModality {
    items?: Modality[];
    count?: number;
    hasMore?: boolean;

    constructor(data?: IPaginatedResponseOfModality) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Modality.fromJS(item));
            }
            this.count = _data["count"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfModality {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfModality();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["count"] = this.count;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IPaginatedResponseOfModality {
    items?: Modality[];
    count?: number;
    hasMore?: boolean;
}

export class Modality implements IModality {
    id?: number;
    name!: string;

    constructor(data?: IModality) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Modality {
        data = typeof data === 'object' ? data : {};
        let result = new Modality();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IModality {
    id?: number;
    name: string;
}

export class Site implements ISite {
    id?: number;
    enabled?: boolean;
    siteName?: string | undefined;
    orgCode?: string | undefined;
    countryCode?: string | undefined;
    region?: string | undefined;
    timeZoneLocation?: string | undefined;

    constructor(data?: ISite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enabled = _data["enabled"];
            this.siteName = _data["siteName"];
            this.orgCode = _data["orgCode"];
            this.countryCode = _data["countryCode"];
            this.region = _data["region"];
            this.timeZoneLocation = _data["timeZoneLocation"];
        }
    }

    static fromJS(data: any): Site {
        data = typeof data === 'object' ? data : {};
        let result = new Site();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enabled"] = this.enabled;
        data["siteName"] = this.siteName;
        data["orgCode"] = this.orgCode;
        data["countryCode"] = this.countryCode;
        data["region"] = this.region;
        data["timeZoneLocation"] = this.timeZoneLocation;
        return data;
    }
}

export interface ISite {
    id?: number;
    enabled?: boolean;
    siteName?: string | undefined;
    orgCode?: string | undefined;
    countryCode?: string | undefined;
    region?: string | undefined;
    timeZoneLocation?: string | undefined;
}

export class PutReferralItem implements IPutReferralItem {
    id?: number | undefined;
    rowVersion?: string | undefined;
    modality?: string;
    bodyPart?: string;
    phaseOfContrast?: string | undefined;

    constructor(data?: IPutReferralItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
            this.modality = _data["modality"];
            this.bodyPart = _data["bodyPart"];
            this.phaseOfContrast = _data["phaseOfContrast"];
        }
    }

    static fromJS(data: any): PutReferralItem {
        data = typeof data === 'object' ? data : {};
        let result = new PutReferralItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        data["modality"] = this.modality;
        data["bodyPart"] = this.bodyPart;
        data["phaseOfContrast"] = this.phaseOfContrast;
        return data;
    }
}

export interface IPutReferralItem {
    id?: number | undefined;
    rowVersion?: string | undefined;
    modality?: string;
    bodyPart?: string;
    phaseOfContrast?: string | undefined;
}

export class GetReferralPrior implements IGetReferralPrior {
    id?: number;
    referralId?: number;
    modality?: string;
    bodyPart?: string;
    priorDate?: string;
    createdAt?: string;
    createdBy?: string;

    constructor(data?: IGetReferralPrior) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referralId = _data["referralId"];
            this.modality = _data["modality"];
            this.bodyPart = _data["bodyPart"];
            this.priorDate = _data["priorDate"];
            this.createdAt = _data["createdAt"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): GetReferralPrior {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralPrior();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referralId"] = this.referralId;
        data["modality"] = this.modality;
        data["bodyPart"] = this.bodyPart;
        data["priorDate"] = this.priorDate;
        data["createdAt"] = this.createdAt;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IGetReferralPrior {
    id?: number;
    referralId?: number;
    modality?: string;
    bodyPart?: string;
    priorDate?: string;
    createdAt?: string;
    createdBy?: string;
}

export class PostReferralPrior implements IPostReferralPrior {
    modality?: string;
    bodyPart?: string;
    priorDate?: string | undefined;

    constructor(data?: IPostReferralPrior) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modality = _data["modality"];
            this.bodyPart = _data["bodyPart"];
            this.priorDate = _data["priorDate"];
        }
    }

    static fromJS(data: any): PostReferralPrior {
        data = typeof data === 'object' ? data : {};
        let result = new PostReferralPrior();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modality"] = this.modality;
        data["bodyPart"] = this.bodyPart;
        data["priorDate"] = this.priorDate;
        return data;
    }
}

export interface IPostReferralPrior {
    modality?: string;
    bodyPart?: string;
    priorDate?: string | undefined;
}

export class PaginatedResponseOfGetReferral implements IPaginatedResponseOfGetReferral {
    items?: GetReferral[];
    count?: number;
    hasMore?: boolean;

    constructor(data?: IPaginatedResponseOfGetReferral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetReferral.fromJS(item));
            }
            this.count = _data["count"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfGetReferral {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfGetReferral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["count"] = this.count;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IPaginatedResponseOfGetReferral {
    items?: GetReferral[];
    count?: number;
    hasMore?: boolean;
}

export class GetReferral implements IGetReferral {
    id?: number;
    rowVersion?: string;
    patient?: GetPatient | undefined;
    orgCode?: string;
    siteId?: number;
    siteName?: string;
    urgency?: UrgencyType | undefined;
    status?: ReferralStatus;
    assignee?: string | undefined;
    referrerName?: string;
    referrerPhone?: string | undefined;
    isTrauma?: boolean;
    strokeQueryType?: StrokeQueryType;
    processInitiatedAt?: string;
    source?: ReferralSource;
    hasLinkedOrders?: boolean;
    timeOfDecision?: string | undefined;
    bodyParts?: GetReferralBodyPart[];
    submittedAt?: string | undefined;
    updatedAt?: string | undefined;
    updatedBy?: string | undefined;
    createdAt?: string;
    createdBy?: string;
    requestedBodyParts?: GetReferralBodyPart[];
    finalisedBodyParts?: GetReferralBodyPart[];
    linkedOrders?: GetLinkedOrder[];
    hasOpenClinicalDiscussion?: boolean;

    constructor(data?: IGetReferral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
            this.patient = _data["patient"] ? GetPatient.fromJS(_data["patient"]) : <any>undefined;
            this.orgCode = _data["orgCode"];
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.urgency = _data["urgency"];
            this.status = _data["status"];
            this.assignee = _data["assignee"];
            this.referrerName = _data["referrerName"];
            this.referrerPhone = _data["referrerPhone"];
            this.isTrauma = _data["isTrauma"];
            this.strokeQueryType = _data["strokeQueryType"];
            this.processInitiatedAt = _data["processInitiatedAt"];
            this.source = _data["source"];
            this.hasLinkedOrders = _data["hasLinkedOrders"];
            this.timeOfDecision = _data["timeOfDecision"];
            if (Array.isArray(_data["bodyParts"])) {
                this.bodyParts = [] as any;
                for (let item of _data["bodyParts"])
                    this.bodyParts!.push(GetReferralBodyPart.fromJS(item));
            }
            this.submittedAt = _data["submittedAt"];
            this.updatedAt = _data["updatedAt"];
            this.updatedBy = _data["updatedBy"];
            this.createdAt = _data["createdAt"];
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["requestedBodyParts"])) {
                this.requestedBodyParts = [] as any;
                for (let item of _data["requestedBodyParts"])
                    this.requestedBodyParts!.push(GetReferralBodyPart.fromJS(item));
            }
            if (Array.isArray(_data["finalisedBodyParts"])) {
                this.finalisedBodyParts = [] as any;
                for (let item of _data["finalisedBodyParts"])
                    this.finalisedBodyParts!.push(GetReferralBodyPart.fromJS(item));
            }
            if (Array.isArray(_data["linkedOrders"])) {
                this.linkedOrders = [] as any;
                for (let item of _data["linkedOrders"])
                    this.linkedOrders!.push(GetLinkedOrder.fromJS(item));
            }
            this.hasOpenClinicalDiscussion = _data["hasOpenClinicalDiscussion"];
        }
    }

    static fromJS(data: any): GetReferral {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["orgCode"] = this.orgCode;
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["urgency"] = this.urgency;
        data["status"] = this.status;
        data["assignee"] = this.assignee;
        data["referrerName"] = this.referrerName;
        data["referrerPhone"] = this.referrerPhone;
        data["isTrauma"] = this.isTrauma;
        data["strokeQueryType"] = this.strokeQueryType;
        data["processInitiatedAt"] = this.processInitiatedAt;
        data["source"] = this.source;
        data["hasLinkedOrders"] = this.hasLinkedOrders;
        data["timeOfDecision"] = this.timeOfDecision;
        if (Array.isArray(this.bodyParts)) {
            data["bodyParts"] = [];
            for (let item of this.bodyParts)
                data["bodyParts"].push(item ? item.toJSON() : <any>undefined);
        }
        data["submittedAt"] = this.submittedAt;
        data["updatedAt"] = this.updatedAt;
        data["updatedBy"] = this.updatedBy;
        data["createdAt"] = this.createdAt;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.requestedBodyParts)) {
            data["requestedBodyParts"] = [];
            for (let item of this.requestedBodyParts)
                data["requestedBodyParts"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.finalisedBodyParts)) {
            data["finalisedBodyParts"] = [];
            for (let item of this.finalisedBodyParts)
                data["finalisedBodyParts"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.linkedOrders)) {
            data["linkedOrders"] = [];
            for (let item of this.linkedOrders)
                data["linkedOrders"].push(item ? item.toJSON() : <any>undefined);
        }
        data["hasOpenClinicalDiscussion"] = this.hasOpenClinicalDiscussion;
        return data;
    }
}

export interface IGetReferral {
    id?: number;
    rowVersion?: string;
    patient?: GetPatient | undefined;
    orgCode?: string;
    siteId?: number;
    siteName?: string;
    urgency?: UrgencyType | undefined;
    status?: ReferralStatus;
    assignee?: string | undefined;
    referrerName?: string;
    referrerPhone?: string | undefined;
    isTrauma?: boolean;
    strokeQueryType?: StrokeQueryType;
    processInitiatedAt?: string;
    source?: ReferralSource;
    hasLinkedOrders?: boolean;
    timeOfDecision?: string | undefined;
    bodyParts?: GetReferralBodyPart[];
    submittedAt?: string | undefined;
    updatedAt?: string | undefined;
    updatedBy?: string | undefined;
    createdAt?: string;
    createdBy?: string;
    requestedBodyParts?: GetReferralBodyPart[];
    finalisedBodyParts?: GetReferralBodyPart[];
    linkedOrders?: GetLinkedOrder[];
    hasOpenClinicalDiscussion?: boolean;
}

export class GetPatient implements IGetPatient {
    id?: number;
    rowVersion?: string;
    patientExternalId?: string;
    orderPatientId?: string | undefined;
    firstName?: string;
    lastName?: string;
    sex?: string | undefined;
    dateOfBirth?: string;
    location?: string | undefined;
    createdAt?: string;
    createdBy?: string;

    constructor(data?: IGetPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
            this.patientExternalId = _data["patientExternalId"];
            this.orderPatientId = _data["orderPatientId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.sex = _data["sex"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.location = _data["location"];
            this.createdAt = _data["createdAt"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): GetPatient {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        data["patientExternalId"] = this.patientExternalId;
        data["orderPatientId"] = this.orderPatientId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["sex"] = this.sex;
        data["dateOfBirth"] = this.dateOfBirth;
        data["location"] = this.location;
        data["createdAt"] = this.createdAt;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IGetPatient {
    id?: number;
    rowVersion?: string;
    patientExternalId?: string;
    orderPatientId?: string | undefined;
    firstName?: string;
    lastName?: string;
    sex?: string | undefined;
    dateOfBirth?: string;
    location?: string | undefined;
    createdAt?: string;
    createdBy?: string;
}

export enum UrgencyType {
    Routine = "Routine",
    Urgent = "Urgent",
    Trauma = "Trauma",
    Stroke = "Stroke",
    TraumaAndStroke = "TraumaAndStroke",
}

export enum ReferralStatus {
    None = "None",
    New = "New",
    AwaitingAssignment = "AwaitingAssignment",
    AwaitingDecision = "AwaitingDecision",
    OnHold = "OnHold",
    Declined = "Declined",
    Deferred = "Deferred",
    AwaitingAcknowledgement = "AwaitingAcknowledgement",
    RequiresFollowUp = "RequiresFollowUp",
    FollowUpInProgress = "FollowUpInProgress",
    FollowedUp = "FollowedUp",
    Acknowledged = "Acknowledged",
    Refused = "Refused",
    ImagesReceived = "ImagesReceived",
    Reported = "Reported",
    Cancelled = "Cancelled",
    ClinicalDiscussionRequired = "ClinicalDiscussionRequired",
}

export enum StrokeQueryType {
    None = "None",
    Unspecified = "Unspecified",
    SimpleStroke = "SimpleStroke",
    Thrombolysis = "Thrombolysis",
    Thrombectomy = "Thrombectomy",
}

export enum ReferralSource {
    Unknown = "Unknown",
    Operations = "Operations",
    ClientApp = "ClientApp",
}

export class GetReferralBodyPart implements IGetReferralBodyPart {
    id?: number;
    modality?: string;
    bodyPart?: string;
    phaseOfContrast?: string | undefined;
    scanNotes?: string | undefined;

    constructor(data?: IGetReferralBodyPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modality = _data["modality"];
            this.bodyPart = _data["bodyPart"];
            this.phaseOfContrast = _data["phaseOfContrast"];
            this.scanNotes = _data["scanNotes"];
        }
    }

    static fromJS(data: any): GetReferralBodyPart {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralBodyPart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modality"] = this.modality;
        data["bodyPart"] = this.bodyPart;
        data["phaseOfContrast"] = this.phaseOfContrast;
        data["scanNotes"] = this.scanNotes;
        return data;
    }
}

export interface IGetReferralBodyPart {
    id?: number;
    modality?: string;
    bodyPart?: string;
    phaseOfContrast?: string | undefined;
    scanNotes?: string | undefined;
}

export class GetLinkedOrder implements IGetLinkedOrder {
    id?: number;
    rowVersion?: string;
    referralId?: number | undefined;
    accessionNumber?: string;
    createdAt?: string;
    createdBy?: string;

    constructor(data?: IGetLinkedOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
            this.referralId = _data["referralId"];
            this.accessionNumber = _data["accessionNumber"];
            this.createdAt = _data["createdAt"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): GetLinkedOrder {
        data = typeof data === 'object' ? data : {};
        let result = new GetLinkedOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        data["referralId"] = this.referralId;
        data["accessionNumber"] = this.accessionNumber;
        data["createdAt"] = this.createdAt;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IGetLinkedOrder {
    id?: number;
    rowVersion?: string;
    referralId?: number | undefined;
    accessionNumber?: string;
    createdAt?: string;
    createdBy?: string;
}

export class GetReferralDetails implements IGetReferralDetails {
    id?: number;
    rowVersion?: string;
    patient?: GetPatient | undefined;
    orgCode?: string;
    siteId?: number;
    siteName?: string;
    referrerName?: string;
    referrerPhone?: string | undefined;
    referrerGrade?: string | undefined;
    urgency?: UrgencyType | undefined;
    confirmation?: boolean;
    status?: ReferralStatus;
    assignee?: string | undefined;
    approvedByDoctor?: string | undefined;
    isTrauma?: boolean;
    strokeQueryType?: StrokeQueryType;
    contrastAllergy?: ContrastAllergyType;
    pregnancy?: PregnancyStatus;
    source?: ReferralSource;
    clinicalHistory?: string | undefined;
    hasPriorPaediatricConsultation?: boolean | undefined;
    differentialDiagnosis?: string | undefined;
    egfrResult?: string | undefined;
    notes?: string | undefined;
    processInitiatedAt?: string;
    submittedAt?: string | undefined;
    updatedAt?: string | undefined;
    updatedBy?: string | undefined;
    createdAt?: string;
    createdBy?: string;
    decisions?: GetDecision[];
    referralItems?: GetReferralItem[];
    linkedOrders?: GetLinkedOrder[];
    priors?: GetReferralPrior[];
    clinicalDiscussions?: GetClinicalDiscussion[];
    reasonForRefusal?: string | undefined;
    reasonForDeferral?: string | undefined;

    constructor(data?: IGetReferralDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
            this.patient = _data["patient"] ? GetPatient.fromJS(_data["patient"]) : <any>undefined;
            this.orgCode = _data["orgCode"];
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.referrerName = _data["referrerName"];
            this.referrerPhone = _data["referrerPhone"];
            this.referrerGrade = _data["referrerGrade"];
            this.urgency = _data["urgency"];
            this.confirmation = _data["confirmation"];
            this.status = _data["status"];
            this.assignee = _data["assignee"];
            this.approvedByDoctor = _data["approvedByDoctor"];
            this.isTrauma = _data["isTrauma"];
            this.strokeQueryType = _data["strokeQueryType"];
            this.contrastAllergy = _data["contrastAllergy"];
            this.pregnancy = _data["pregnancy"];
            this.source = _data["source"];
            this.clinicalHistory = _data["clinicalHistory"];
            this.hasPriorPaediatricConsultation = _data["hasPriorPaediatricConsultation"];
            this.differentialDiagnosis = _data["differentialDiagnosis"];
            this.egfrResult = _data["egfrResult"];
            this.notes = _data["notes"];
            this.processInitiatedAt = _data["processInitiatedAt"];
            this.submittedAt = _data["submittedAt"];
            this.updatedAt = _data["updatedAt"];
            this.updatedBy = _data["updatedBy"];
            this.createdAt = _data["createdAt"];
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["decisions"])) {
                this.decisions = [] as any;
                for (let item of _data["decisions"])
                    this.decisions!.push(GetDecision.fromJS(item));
            }
            if (Array.isArray(_data["referralItems"])) {
                this.referralItems = [] as any;
                for (let item of _data["referralItems"])
                    this.referralItems!.push(GetReferralItem.fromJS(item));
            }
            if (Array.isArray(_data["linkedOrders"])) {
                this.linkedOrders = [] as any;
                for (let item of _data["linkedOrders"])
                    this.linkedOrders!.push(GetLinkedOrder.fromJS(item));
            }
            if (Array.isArray(_data["priors"])) {
                this.priors = [] as any;
                for (let item of _data["priors"])
                    this.priors!.push(GetReferralPrior.fromJS(item));
            }
            if (Array.isArray(_data["clinicalDiscussions"])) {
                this.clinicalDiscussions = [] as any;
                for (let item of _data["clinicalDiscussions"])
                    this.clinicalDiscussions!.push(GetClinicalDiscussion.fromJS(item));
            }
            this.reasonForRefusal = _data["reasonForRefusal"];
            this.reasonForDeferral = _data["reasonForDeferral"];
        }
    }

    static fromJS(data: any): GetReferralDetails {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["orgCode"] = this.orgCode;
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["referrerName"] = this.referrerName;
        data["referrerPhone"] = this.referrerPhone;
        data["referrerGrade"] = this.referrerGrade;
        data["urgency"] = this.urgency;
        data["confirmation"] = this.confirmation;
        data["status"] = this.status;
        data["assignee"] = this.assignee;
        data["approvedByDoctor"] = this.approvedByDoctor;
        data["isTrauma"] = this.isTrauma;
        data["strokeQueryType"] = this.strokeQueryType;
        data["contrastAllergy"] = this.contrastAllergy;
        data["pregnancy"] = this.pregnancy;
        data["source"] = this.source;
        data["clinicalHistory"] = this.clinicalHistory;
        data["hasPriorPaediatricConsultation"] = this.hasPriorPaediatricConsultation;
        data["differentialDiagnosis"] = this.differentialDiagnosis;
        data["egfrResult"] = this.egfrResult;
        data["notes"] = this.notes;
        data["processInitiatedAt"] = this.processInitiatedAt;
        data["submittedAt"] = this.submittedAt;
        data["updatedAt"] = this.updatedAt;
        data["updatedBy"] = this.updatedBy;
        data["createdAt"] = this.createdAt;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.decisions)) {
            data["decisions"] = [];
            for (let item of this.decisions)
                data["decisions"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.referralItems)) {
            data["referralItems"] = [];
            for (let item of this.referralItems)
                data["referralItems"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.linkedOrders)) {
            data["linkedOrders"] = [];
            for (let item of this.linkedOrders)
                data["linkedOrders"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.priors)) {
            data["priors"] = [];
            for (let item of this.priors)
                data["priors"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.clinicalDiscussions)) {
            data["clinicalDiscussions"] = [];
            for (let item of this.clinicalDiscussions)
                data["clinicalDiscussions"].push(item ? item.toJSON() : <any>undefined);
        }
        data["reasonForRefusal"] = this.reasonForRefusal;
        data["reasonForDeferral"] = this.reasonForDeferral;
        return data;
    }
}

export interface IGetReferralDetails {
    id?: number;
    rowVersion?: string;
    patient?: GetPatient | undefined;
    orgCode?: string;
    siteId?: number;
    siteName?: string;
    referrerName?: string;
    referrerPhone?: string | undefined;
    referrerGrade?: string | undefined;
    urgency?: UrgencyType | undefined;
    confirmation?: boolean;
    status?: ReferralStatus;
    assignee?: string | undefined;
    approvedByDoctor?: string | undefined;
    isTrauma?: boolean;
    strokeQueryType?: StrokeQueryType;
    contrastAllergy?: ContrastAllergyType;
    pregnancy?: PregnancyStatus;
    source?: ReferralSource;
    clinicalHistory?: string | undefined;
    hasPriorPaediatricConsultation?: boolean | undefined;
    differentialDiagnosis?: string | undefined;
    egfrResult?: string | undefined;
    notes?: string | undefined;
    processInitiatedAt?: string;
    submittedAt?: string | undefined;
    updatedAt?: string | undefined;
    updatedBy?: string | undefined;
    createdAt?: string;
    createdBy?: string;
    decisions?: GetDecision[];
    referralItems?: GetReferralItem[];
    linkedOrders?: GetLinkedOrder[];
    priors?: GetReferralPrior[];
    clinicalDiscussions?: GetClinicalDiscussion[];
    reasonForRefusal?: string | undefined;
    reasonForDeferral?: string | undefined;
}

export class GetDecision implements IGetDecision {
    id?: number;
    rowVersion?: string;
    referralId?: number;
    decisionType?: DecisionType;
    egfrResult?: string | undefined;
    clinicalNotes?: string | undefined;
    reason?: string | undefined;
    decidedAt?: string | undefined;
    decidedBy?: string | undefined;
    gmc?: string | undefined;
    imc?: string | undefined;
    acknowledgedAt?: string | undefined;
    acknowledgedBy?: string | undefined;
    covid19?: Covid19Result | undefined;
    notesForReportingRadiologist?: string | undefined;
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
    decisionItems?: GetDecisionItem[];

    constructor(data?: IGetDecision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
            this.referralId = _data["referralId"];
            this.decisionType = _data["decisionType"];
            this.egfrResult = _data["egfrResult"];
            this.clinicalNotes = _data["clinicalNotes"];
            this.reason = _data["reason"];
            this.decidedAt = _data["decidedAt"];
            this.decidedBy = _data["decidedBy"];
            this.gmc = _data["gmc"];
            this.imc = _data["imc"];
            this.acknowledgedAt = _data["acknowledgedAt"];
            this.acknowledgedBy = _data["acknowledgedBy"];
            this.covid19 = _data["covid19"];
            this.notesForReportingRadiologist = _data["notesForReportingRadiologist"];
            this.createdAt = _data["createdAt"];
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"];
            this.updatedBy = _data["updatedBy"];
            if (Array.isArray(_data["decisionItems"])) {
                this.decisionItems = [] as any;
                for (let item of _data["decisionItems"])
                    this.decisionItems!.push(GetDecisionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDecision {
        data = typeof data === 'object' ? data : {};
        let result = new GetDecision();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        data["referralId"] = this.referralId;
        data["decisionType"] = this.decisionType;
        data["egfrResult"] = this.egfrResult;
        data["clinicalNotes"] = this.clinicalNotes;
        data["reason"] = this.reason;
        data["decidedAt"] = this.decidedAt;
        data["decidedBy"] = this.decidedBy;
        data["gmc"] = this.gmc;
        data["imc"] = this.imc;
        data["acknowledgedAt"] = this.acknowledgedAt;
        data["acknowledgedBy"] = this.acknowledgedBy;
        data["covid19"] = this.covid19;
        data["notesForReportingRadiologist"] = this.notesForReportingRadiologist;
        data["createdAt"] = this.createdAt;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt;
        data["updatedBy"] = this.updatedBy;
        if (Array.isArray(this.decisionItems)) {
            data["decisionItems"] = [];
            for (let item of this.decisionItems)
                data["decisionItems"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IGetDecision {
    id?: number;
    rowVersion?: string;
    referralId?: number;
    decisionType?: DecisionType;
    egfrResult?: string | undefined;
    clinicalNotes?: string | undefined;
    reason?: string | undefined;
    decidedAt?: string | undefined;
    decidedBy?: string | undefined;
    gmc?: string | undefined;
    imc?: string | undefined;
    acknowledgedAt?: string | undefined;
    acknowledgedBy?: string | undefined;
    covid19?: Covid19Result | undefined;
    notesForReportingRadiologist?: string | undefined;
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
    decisionItems?: GetDecisionItem[];
}

export enum DecisionType {
    None = "None",
    Approved = "Approved",
    Declined = "Declined",
    Pending = "Pending",
}

export enum Covid19Result {
    None = "None",
    No = "No",
    Suspicion = "Suspicion",
    Yes = "Yes",
    NotAvailable = "NotAvailable",
}

export class GetDecisionItem implements IGetDecisionItem {
    id?: number;
    rowVersion?: string;
    decisionId?: number;
    modality?: string | undefined;
    bodyPart?: string | undefined;
    phaseOfContrast?: string | undefined;
    scanNotes?: string | undefined;
    createdAt?: string;
    createdBy?: string;

    constructor(data?: IGetDecisionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
            this.decisionId = _data["decisionId"];
            this.modality = _data["modality"];
            this.bodyPart = _data["bodyPart"];
            this.phaseOfContrast = _data["phaseOfContrast"];
            this.scanNotes = _data["scanNotes"];
            this.createdAt = _data["createdAt"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): GetDecisionItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetDecisionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        data["decisionId"] = this.decisionId;
        data["modality"] = this.modality;
        data["bodyPart"] = this.bodyPart;
        data["phaseOfContrast"] = this.phaseOfContrast;
        data["scanNotes"] = this.scanNotes;
        data["createdAt"] = this.createdAt;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IGetDecisionItem {
    id?: number;
    rowVersion?: string;
    decisionId?: number;
    modality?: string | undefined;
    bodyPart?: string | undefined;
    phaseOfContrast?: string | undefined;
    scanNotes?: string | undefined;
    createdAt?: string;
    createdBy?: string;
}

export class GetReferralItem implements IGetReferralItem {
    id?: number;
    rowVersion?: string;
    referralId?: number;
    modality?: string;
    bodyPart?: string;
    phaseOfContrast?: string | undefined;
    createdAt?: string;
    createdBy?: string;

    constructor(data?: IGetReferralItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
            this.referralId = _data["referralId"];
            this.modality = _data["modality"];
            this.bodyPart = _data["bodyPart"];
            this.phaseOfContrast = _data["phaseOfContrast"];
            this.createdAt = _data["createdAt"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): GetReferralItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        data["referralId"] = this.referralId;
        data["modality"] = this.modality;
        data["bodyPart"] = this.bodyPart;
        data["phaseOfContrast"] = this.phaseOfContrast;
        data["createdAt"] = this.createdAt;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IGetReferralItem {
    id?: number;
    rowVersion?: string;
    referralId?: number;
    modality?: string;
    bodyPart?: string;
    phaseOfContrast?: string | undefined;
    createdAt?: string;
    createdBy?: string;
}

export class GetClinicalDiscussion implements IGetClinicalDiscussion {
    id?: number;
    type?: ClinicalDiscussionType;
    status?: ClinicalDiscussionStatus;
    rowVersion?: string;

    constructor(data?: IGetClinicalDiscussion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): GetClinicalDiscussion {
        data = typeof data === 'object' ? data : {};
        let result = new GetClinicalDiscussion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["status"] = this.status;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IGetClinicalDiscussion {
    id?: number;
    type?: ClinicalDiscussionType;
    status?: ClinicalDiscussionStatus;
    rowVersion?: string;
}

export enum ClinicalDiscussionType {
    Unknown = 0,
    Mandatory = 1,
    RequestedByEdClinician = 2,
    RequestedByRadiologist = 3,
    RequestedByOperations = 4,
}

export class PostReferral implements IPostReferral {
    referralItems?: PostReferralItem[];
    patient?: PostPatient;
    orgCode?: string;
    siteId?: number | undefined;
    referrerName?: string;
    referrerPhone?: string;
    confirmation?: boolean | undefined;
    approvedByDoctor?: string | undefined;
    isTrauma?: boolean | undefined;
    strokeQueryType?: StrokeQueryType | undefined;
    contrastAllergy?: ContrastAllergyType | undefined;
    pregnancy?: PregnancyStatus | undefined;
    hasPriorPaediatricConsultation?: boolean | undefined;
    clinicalHistory?: string;
    differentialDiagnosis?: string;
    egfrResult?: string;
    priors?: PostReferralPrior[] | undefined;
    autoPopulatedFromIntegratedProtoReferrals?: boolean | undefined;
    processInitiatedAt?: string | undefined;
    requestClinicalDiscussion?: boolean;

    constructor(data?: IPostReferral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["referralItems"])) {
                this.referralItems = [] as any;
                for (let item of _data["referralItems"])
                    this.referralItems!.push(PostReferralItem.fromJS(item));
            }
            this.patient = _data["patient"] ? PostPatient.fromJS(_data["patient"]) : <any>undefined;
            this.orgCode = _data["orgCode"];
            this.siteId = _data["siteId"];
            this.referrerName = _data["referrerName"];
            this.referrerPhone = _data["referrerPhone"];
            this.confirmation = _data["confirmation"];
            this.approvedByDoctor = _data["approvedByDoctor"];
            this.isTrauma = _data["isTrauma"];
            this.strokeQueryType = _data["strokeQueryType"];
            this.contrastAllergy = _data["contrastAllergy"];
            this.pregnancy = _data["pregnancy"];
            this.hasPriorPaediatricConsultation = _data["hasPriorPaediatricConsultation"];
            this.clinicalHistory = _data["clinicalHistory"];
            this.differentialDiagnosis = _data["differentialDiagnosis"];
            this.egfrResult = _data["egfrResult"];
            if (Array.isArray(_data["priors"])) {
                this.priors = [] as any;
                for (let item of _data["priors"])
                    this.priors!.push(PostReferralPrior.fromJS(item));
            }
            this.autoPopulatedFromIntegratedProtoReferrals = _data["autoPopulatedFromIntegratedProtoReferrals"];
            this.processInitiatedAt = _data["processInitiatedAt"];
            this.requestClinicalDiscussion = _data["requestClinicalDiscussion"];
        }
    }

    static fromJS(data: any): PostReferral {
        data = typeof data === 'object' ? data : {};
        let result = new PostReferral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.referralItems)) {
            data["referralItems"] = [];
            for (let item of this.referralItems)
                data["referralItems"].push(item ? item.toJSON() : <any>undefined);
        }
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["orgCode"] = this.orgCode;
        data["siteId"] = this.siteId;
        data["referrerName"] = this.referrerName;
        data["referrerPhone"] = this.referrerPhone;
        data["confirmation"] = this.confirmation;
        data["approvedByDoctor"] = this.approvedByDoctor;
        data["isTrauma"] = this.isTrauma;
        data["strokeQueryType"] = this.strokeQueryType;
        data["contrastAllergy"] = this.contrastAllergy;
        data["pregnancy"] = this.pregnancy;
        data["hasPriorPaediatricConsultation"] = this.hasPriorPaediatricConsultation;
        data["clinicalHistory"] = this.clinicalHistory;
        data["differentialDiagnosis"] = this.differentialDiagnosis;
        data["egfrResult"] = this.egfrResult;
        if (Array.isArray(this.priors)) {
            data["priors"] = [];
            for (let item of this.priors)
                data["priors"].push(item ? item.toJSON() : <any>undefined);
        }
        data["autoPopulatedFromIntegratedProtoReferrals"] = this.autoPopulatedFromIntegratedProtoReferrals;
        data["processInitiatedAt"] = this.processInitiatedAt;
        data["requestClinicalDiscussion"] = this.requestClinicalDiscussion;
        return data;
    }
}

export interface IPostReferral {
    referralItems?: PostReferralItem[];
    patient?: PostPatient;
    orgCode?: string;
    siteId?: number | undefined;
    referrerName?: string;
    referrerPhone?: string;
    confirmation?: boolean | undefined;
    approvedByDoctor?: string | undefined;
    isTrauma?: boolean | undefined;
    strokeQueryType?: StrokeQueryType | undefined;
    contrastAllergy?: ContrastAllergyType | undefined;
    pregnancy?: PregnancyStatus | undefined;
    hasPriorPaediatricConsultation?: boolean | undefined;
    clinicalHistory?: string;
    differentialDiagnosis?: string;
    egfrResult?: string;
    priors?: PostReferralPrior[] | undefined;
    autoPopulatedFromIntegratedProtoReferrals?: boolean | undefined;
    processInitiatedAt?: string | undefined;
    requestClinicalDiscussion?: boolean;
}

export class PostReferralItem implements IPostReferralItem {
    modality?: string;
    bodyPart?: string;
    phaseOfContrast?: string | undefined;

    constructor(data?: IPostReferralItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modality = _data["modality"];
            this.bodyPart = _data["bodyPart"];
            this.phaseOfContrast = _data["phaseOfContrast"];
        }
    }

    static fromJS(data: any): PostReferralItem {
        data = typeof data === 'object' ? data : {};
        let result = new PostReferralItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modality"] = this.modality;
        data["bodyPart"] = this.bodyPart;
        data["phaseOfContrast"] = this.phaseOfContrast;
        return data;
    }
}

export interface IPostReferralItem {
    modality?: string;
    bodyPart?: string;
    phaseOfContrast?: string | undefined;
}

export class PostPatient implements IPostPatient {
    patientExternalId?: string;
    firstName?: string;
    lastName?: string;
    dateOfBirth?: string | undefined;
    location?: string;

    constructor(data?: IPostPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientExternalId = _data["patientExternalId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): PostPatient {
        data = typeof data === 'object' ? data : {};
        let result = new PostPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientExternalId"] = this.patientExternalId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth;
        data["location"] = this.location;
        return data;
    }
}

export interface IPostPatient {
    patientExternalId?: string;
    firstName?: string;
    lastName?: string;
    dateOfBirth?: string | undefined;
    location?: string;
}

export class PatchReferral implements IPatchReferral {
    rowVersion?: string;
    patient?: PatchPatient | undefined;
    referrerName?: string | undefined;
    referrerPhone?: string | undefined;
    confirmation?: boolean | undefined;
    approvedByDoctor?: string | undefined;
    isTrauma?: boolean | undefined;
    strokeQueryType?: StrokeQueryType | undefined;
    contrastAllergy?: ContrastAllergyType | undefined;
    pregnancy?: PregnancyStatus | undefined;
    hasPriorPaediatricConsultation?: boolean | undefined;
    clinicalHistory?: string | undefined;
    differentialDiagnosis?: string | undefined;
    egfrResult?: string | undefined;

    constructor(data?: IPatchReferral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowVersion = _data["rowVersion"];
            this.patient = _data["patient"] ? PatchPatient.fromJS(_data["patient"]) : <any>undefined;
            this.referrerName = _data["referrerName"];
            this.referrerPhone = _data["referrerPhone"];
            this.confirmation = _data["confirmation"];
            this.approvedByDoctor = _data["approvedByDoctor"];
            this.isTrauma = _data["isTrauma"];
            this.strokeQueryType = _data["strokeQueryType"];
            this.contrastAllergy = _data["contrastAllergy"];
            this.pregnancy = _data["pregnancy"];
            this.hasPriorPaediatricConsultation = _data["hasPriorPaediatricConsultation"];
            this.clinicalHistory = _data["clinicalHistory"];
            this.differentialDiagnosis = _data["differentialDiagnosis"];
            this.egfrResult = _data["egfrResult"];
        }
    }

    static fromJS(data: any): PatchReferral {
        data = typeof data === 'object' ? data : {};
        let result = new PatchReferral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowVersion"] = this.rowVersion;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["referrerName"] = this.referrerName;
        data["referrerPhone"] = this.referrerPhone;
        data["confirmation"] = this.confirmation;
        data["approvedByDoctor"] = this.approvedByDoctor;
        data["isTrauma"] = this.isTrauma;
        data["strokeQueryType"] = this.strokeQueryType;
        data["contrastAllergy"] = this.contrastAllergy;
        data["pregnancy"] = this.pregnancy;
        data["hasPriorPaediatricConsultation"] = this.hasPriorPaediatricConsultation;
        data["clinicalHistory"] = this.clinicalHistory;
        data["differentialDiagnosis"] = this.differentialDiagnosis;
        data["egfrResult"] = this.egfrResult;
        return data;
    }
}

export interface IPatchReferral {
    rowVersion?: string;
    patient?: PatchPatient | undefined;
    referrerName?: string | undefined;
    referrerPhone?: string | undefined;
    confirmation?: boolean | undefined;
    approvedByDoctor?: string | undefined;
    isTrauma?: boolean | undefined;
    strokeQueryType?: StrokeQueryType | undefined;
    contrastAllergy?: ContrastAllergyType | undefined;
    pregnancy?: PregnancyStatus | undefined;
    hasPriorPaediatricConsultation?: boolean | undefined;
    clinicalHistory?: string | undefined;
    differentialDiagnosis?: string | undefined;
    egfrResult?: string | undefined;
}

export class PatchPatient implements IPatchPatient {
    rowVersion?: string;
    patientExternalId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: string | undefined;
    location?: string | undefined;

    constructor(data?: IPatchPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowVersion = _data["rowVersion"];
            this.patientExternalId = _data["patientExternalId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): PatchPatient {
        data = typeof data === 'object' ? data : {};
        let result = new PatchPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowVersion"] = this.rowVersion;
        data["patientExternalId"] = this.patientExternalId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth;
        data["location"] = this.location;
        return data;
    }
}

export interface IPatchPatient {
    rowVersion?: string;
    patientExternalId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: string | undefined;
    location?: string | undefined;
}

export class AcknowledgeReferralRequest implements IAcknowledgeReferralRequest {
    rowVersion?: string;
    willAcknowledgeReferral?: boolean;
    reasonForRefusal?: string | undefined;
    reasonForDeferral?: string | undefined;

    constructor(data?: IAcknowledgeReferralRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowVersion = _data["rowVersion"];
            this.willAcknowledgeReferral = _data["willAcknowledgeReferral"];
            this.reasonForRefusal = _data["reasonForRefusal"];
            this.reasonForDeferral = _data["reasonForDeferral"];
        }
    }

    static fromJS(data: any): AcknowledgeReferralRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AcknowledgeReferralRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowVersion"] = this.rowVersion;
        data["willAcknowledgeReferral"] = this.willAcknowledgeReferral;
        data["reasonForRefusal"] = this.reasonForRefusal;
        data["reasonForDeferral"] = this.reasonForDeferral;
        return data;
    }
}

export interface IAcknowledgeReferralRequest {
    rowVersion?: string;
    willAcknowledgeReferral?: boolean;
    reasonForRefusal?: string | undefined;
    reasonForDeferral?: string | undefined;
}

export class GetReferralLinkingDetails implements IGetReferralLinkingDetails {
    linkedReferral?: GetReferralDetails | undefined;
    linkedOrderId?: number | undefined;
    orderAccessionNumber?: string;

    constructor(data?: IGetReferralLinkingDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkedReferral = _data["linkedReferral"] ? GetReferralDetails.fromJS(_data["linkedReferral"]) : <any>undefined;
            this.linkedOrderId = _data["linkedOrderId"];
            this.orderAccessionNumber = _data["orderAccessionNumber"];
        }
    }

    static fromJS(data: any): GetReferralLinkingDetails {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralLinkingDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkedReferral"] = this.linkedReferral ? this.linkedReferral.toJSON() : <any>undefined;
        data["linkedOrderId"] = this.linkedOrderId;
        data["orderAccessionNumber"] = this.orderAccessionNumber;
        return data;
    }
}

export interface IGetReferralLinkingDetails {
    linkedReferral?: GetReferralDetails | undefined;
    linkedOrderId?: number | undefined;
    orderAccessionNumber?: string;
}

export class RemoteOrderRequest implements IRemoteOrderRequest {
    details?: RemoteOrderDetails;
    items?: RemoteOrderItem[];
    priors?: RemoteOrderPrior[];

    constructor(data?: IRemoteOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.details = _data["details"] ? RemoteOrderDetails.fromJS(_data["details"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RemoteOrderItem.fromJS(item));
            }
            if (Array.isArray(_data["priors"])) {
                this.priors = [] as any;
                for (let item of _data["priors"])
                    this.priors!.push(RemoteOrderPrior.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RemoteOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.priors)) {
            data["priors"] = [];
            for (let item of this.priors)
                data["priors"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRemoteOrderRequest {
    details?: RemoteOrderDetails;
    items?: RemoteOrderItem[];
    priors?: RemoteOrderPrior[];
}

export class RemoteOrderDetails implements IRemoteOrderDetails {
    patientLastName?: string;
    patientFirstName?: string;
    patientBirthDate?: string | undefined;
    patientLocation?: string;
    callersName?: string;
    contactPhone?: string;
    orgCode?: string;
    siteId?: number | undefined;
    urgency?: string;
    notes?: string | undefined;
    verbalRequired?: boolean | undefined;
    referringDoctorCountryCode?: string;
    referringDoctorPhoneNo?: string;
    referringDoctorExtension?: string | undefined;
    verbalDoctorReceivingReport?: string;
    medicalRecordNumber?: string;
    accessionNumber?: string | undefined;
    radiographerNotes?: string | undefined;
    traumaProtocol?: boolean | undefined;
    strokeProtocolType?: StrokeProtocol | undefined;
    commonStudiesIDs?: string | undefined;
    priorSent?: boolean | undefined;
    radiographerName?: string | undefined;
    radiographerPhone?: string | undefined;
    protocol?: string;

    constructor(data?: IRemoteOrderDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientLastName = _data["patientLastName"];
            this.patientFirstName = _data["patientFirstName"];
            this.patientBirthDate = _data["patientBirthDate"];
            this.patientLocation = _data["patientLocation"];
            this.callersName = _data["callersName"];
            this.contactPhone = _data["contactPhone"];
            this.orgCode = _data["orgCode"];
            this.siteId = _data["siteId"];
            this.urgency = _data["urgency"];
            this.notes = _data["notes"];
            this.verbalRequired = _data["verbalRequired"];
            this.referringDoctorCountryCode = _data["referringDoctorCountryCode"];
            this.referringDoctorPhoneNo = _data["referringDoctorPhoneNo"];
            this.referringDoctorExtension = _data["referringDoctorExtension"];
            this.verbalDoctorReceivingReport = _data["verbalDoctorReceivingReport"];
            this.medicalRecordNumber = _data["medicalRecordNumber"];
            this.accessionNumber = _data["accessionNumber"];
            this.radiographerNotes = _data["radiographerNotes"];
            this.traumaProtocol = _data["traumaProtocol"];
            this.strokeProtocolType = _data["strokeProtocolType"];
            this.commonStudiesIDs = _data["commonStudiesIDs"];
            this.priorSent = _data["priorSent"];
            this.radiographerName = _data["radiographerName"];
            this.radiographerPhone = _data["radiographerPhone"];
            this.protocol = _data["protocol"];
        }
    }

    static fromJS(data: any): RemoteOrderDetails {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteOrderDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientLastName"] = this.patientLastName;
        data["patientFirstName"] = this.patientFirstName;
        data["patientBirthDate"] = this.patientBirthDate;
        data["patientLocation"] = this.patientLocation;
        data["callersName"] = this.callersName;
        data["contactPhone"] = this.contactPhone;
        data["orgCode"] = this.orgCode;
        data["siteId"] = this.siteId;
        data["urgency"] = this.urgency;
        data["notes"] = this.notes;
        data["verbalRequired"] = this.verbalRequired;
        data["referringDoctorCountryCode"] = this.referringDoctorCountryCode;
        data["referringDoctorPhoneNo"] = this.referringDoctorPhoneNo;
        data["referringDoctorExtension"] = this.referringDoctorExtension;
        data["verbalDoctorReceivingReport"] = this.verbalDoctorReceivingReport;
        data["medicalRecordNumber"] = this.medicalRecordNumber;
        data["accessionNumber"] = this.accessionNumber;
        data["radiographerNotes"] = this.radiographerNotes;
        data["traumaProtocol"] = this.traumaProtocol;
        data["strokeProtocolType"] = this.strokeProtocolType;
        data["commonStudiesIDs"] = this.commonStudiesIDs;
        data["priorSent"] = this.priorSent;
        data["radiographerName"] = this.radiographerName;
        data["radiographerPhone"] = this.radiographerPhone;
        data["protocol"] = this.protocol;
        return data;
    }
}

export interface IRemoteOrderDetails {
    patientLastName?: string;
    patientFirstName?: string;
    patientBirthDate?: string | undefined;
    patientLocation?: string;
    callersName?: string;
    contactPhone?: string;
    orgCode?: string;
    siteId?: number | undefined;
    urgency?: string;
    notes?: string | undefined;
    verbalRequired?: boolean | undefined;
    referringDoctorCountryCode?: string;
    referringDoctorPhoneNo?: string;
    referringDoctorExtension?: string | undefined;
    verbalDoctorReceivingReport?: string;
    medicalRecordNumber?: string;
    accessionNumber?: string | undefined;
    radiographerNotes?: string | undefined;
    traumaProtocol?: boolean | undefined;
    strokeProtocolType?: StrokeProtocol | undefined;
    commonStudiesIDs?: string | undefined;
    priorSent?: boolean | undefined;
    radiographerName?: string | undefined;
    radiographerPhone?: string | undefined;
    protocol?: string;
}

export enum StrokeProtocol {
    None = "None",
    Unspecified = "Unspecified",
    SimpleStroke = "SimpleStroke",
    Thrombolysis = "Thrombolysis",
    Thrombectomy = "Thrombectomy",
}

export class RemoteOrderItem implements IRemoteOrderItem {
    accessionNumber?: string | undefined;
    itemDescription?: string;
    modality?: string;
    studyId?: number;
    imageCount?: number | undefined;

    constructor(data?: IRemoteOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessionNumber = _data["accessionNumber"];
            this.itemDescription = _data["itemDescription"];
            this.modality = _data["modality"];
            this.studyId = _data["studyId"];
            this.imageCount = _data["imageCount"];
        }
    }

    static fromJS(data: any): RemoteOrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteOrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessionNumber"] = this.accessionNumber;
        data["itemDescription"] = this.itemDescription;
        data["modality"] = this.modality;
        data["studyId"] = this.studyId;
        data["imageCount"] = this.imageCount;
        return data;
    }
}

export interface IRemoteOrderItem {
    accessionNumber?: string | undefined;
    itemDescription?: string;
    modality?: string;
    studyId?: number;
    imageCount?: number | undefined;
}

export class RemoteOrderPrior implements IRemoteOrderPrior {
    accessionNumber?: string | undefined;
    modality?: string;
    priorDate?: string | undefined;

    constructor(data?: IRemoteOrderPrior) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessionNumber = _data["accessionNumber"];
            this.modality = _data["modality"];
            this.priorDate = _data["priorDate"];
        }
    }

    static fromJS(data: any): RemoteOrderPrior {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteOrderPrior();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessionNumber"] = this.accessionNumber;
        data["modality"] = this.modality;
        data["priorDate"] = this.priorDate;
        return data;
    }
}

export interface IRemoteOrderPrior {
    accessionNumber?: string | undefined;
    modality?: string;
    priorDate?: string | undefined;
}

export class GetClient implements IGetClient {
    orgCode?: string;
    settings?: GetClientSetting[];
    countryCode?: string | undefined;
    clientName?: string | undefined;

    constructor(data?: IGetClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orgCode = _data["orgCode"];
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(GetClientSetting.fromJS(item));
            }
            this.countryCode = _data["countryCode"];
            this.clientName = _data["clientName"];
        }
    }

    static fromJS(data: any): GetClient {
        data = typeof data === 'object' ? data : {};
        let result = new GetClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orgCode"] = this.orgCode;
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item ? item.toJSON() : <any>undefined);
        }
        data["countryCode"] = this.countryCode;
        data["clientName"] = this.clientName;
        return data;
    }
}

export interface IGetClient {
    orgCode?: string;
    settings?: GetClientSetting[];
    countryCode?: string | undefined;
    clientName?: string | undefined;
}

export class GetClientSetting implements IGetClientSetting {
    settingType?: SettingType;
    orgCode?: string;
    sites?: GetSiteSetting[];
    settingValue?: string | undefined;

    constructor(data?: IGetClientSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingType = _data["settingType"];
            this.orgCode = _data["orgCode"];
            if (Array.isArray(_data["sites"])) {
                this.sites = [] as any;
                for (let item of _data["sites"])
                    this.sites!.push(GetSiteSetting.fromJS(item));
            }
            this.settingValue = _data["settingValue"];
        }
    }

    static fromJS(data: any): GetClientSetting {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingType"] = this.settingType;
        data["orgCode"] = this.orgCode;
        if (Array.isArray(this.sites)) {
            data["sites"] = [];
            for (let item of this.sites)
                data["sites"].push(item ? item.toJSON() : <any>undefined);
        }
        data["settingValue"] = this.settingValue;
        return data;
    }
}

export interface IGetClientSetting {
    settingType?: SettingType;
    orgCode?: string;
    sites?: GetSiteSetting[];
    settingValue?: string | undefined;
}

export enum SettingType {
    AutoFax = 1,
    VerbalPreventsBreach = 2,
    PasteCopyOfReport = 3,
    HL7 = 4,
    PriorsWorkFlow = 5,
    UrgentCoverageHoursStart = 6,
    UrgentCoverageHoursEnd = 7,
    VerbalRequiredForUrgent = 8,
    PriorityClient = 9,
    MfaEnabled = 10,
    ImagingOverviewEnabled = 11,
    ClientReferralCreation = 12,
    AppendSignTime = 13,
    DemandManagement = 14,
    IntegratedReferrals = 15,
}

export class GetSiteSetting implements IGetSiteSetting {
    siteId?: number;
    settingValue?: string;

    constructor(data?: IGetSiteSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"];
            this.settingValue = _data["settingValue"];
        }
    }

    static fromJS(data: any): GetSiteSetting {
        data = typeof data === 'object' ? data : {};
        let result = new GetSiteSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId;
        data["settingValue"] = this.settingValue;
        return data;
    }
}

export interface IGetSiteSetting {
    siteId?: number;
    settingValue?: string;
}

export class WorklistItemDto implements IWorklistItemDto {
    id?: string | undefined;
    accessionNumber?: string | undefined;
    orgCode?: string;
    siteId?: number | undefined;
    siteName?: string | undefined;
    dataSource?: WorklistItemDataSourceType;
    mrn?: string | undefined;
    patientName?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientBirthDate?: string | undefined;
    urgency?: UrgencyType | undefined;
    traumaProtocol?: boolean | undefined;
    strokeProtocolType?: StrokeProtocol | undefined;
    status?: StatusType | undefined;
    studyDateTime?: string | undefined;
    modality?: string | undefined;
    studyDescription?: string | undefined;
    signedAt?: string | undefined;
    createdAt?: string | undefined;
    hasAssignedTo?: boolean | undefined;
    lastUpdatedAt?: string | undefined;
    noOfImagesExpected?: number | undefined;
    noOfImagesArrived?: number | undefined;
    referringDoctor?: string | undefined;
    referringDoctorPhone?: string | undefined;
    patientLocation?: string | undefined;
    onHold?: boolean | undefined;
    onHoldUpdatedAt?: string | undefined;
    linkedReferralInformation?: GetLinkedReferralInformation | undefined;

    constructor(data?: IWorklistItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accessionNumber = _data["accessionNumber"];
            this.orgCode = _data["orgCode"];
            this.siteId = _data["siteId"];
            this.siteName = _data["siteName"];
            this.dataSource = _data["dataSource"];
            this.mrn = _data["mrn"];
            this.patientName = _data["patientName"];
            this.patientFirstName = _data["patientFirstName"];
            this.patientLastName = _data["patientLastName"];
            this.patientBirthDate = _data["patientBirthDate"];
            this.urgency = _data["urgency"];
            this.traumaProtocol = _data["traumaProtocol"];
            this.strokeProtocolType = _data["strokeProtocolType"];
            this.status = _data["status"];
            this.studyDateTime = _data["studyDateTime"];
            this.modality = _data["modality"];
            this.studyDescription = _data["studyDescription"];
            this.signedAt = _data["signedAt"];
            this.createdAt = _data["createdAt"];
            this.hasAssignedTo = _data["hasAssignedTo"];
            this.lastUpdatedAt = _data["lastUpdatedAt"];
            this.noOfImagesExpected = _data["noOfImagesExpected"];
            this.noOfImagesArrived = _data["noOfImagesArrived"];
            this.referringDoctor = _data["referringDoctor"];
            this.referringDoctorPhone = _data["referringDoctorPhone"];
            this.patientLocation = _data["patientLocation"];
            this.onHold = _data["onHold"];
            this.onHoldUpdatedAt = _data["onHoldUpdatedAt"];
            this.linkedReferralInformation = _data["linkedReferralInformation"] ? GetLinkedReferralInformation.fromJS(_data["linkedReferralInformation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorklistItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorklistItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessionNumber"] = this.accessionNumber;
        data["orgCode"] = this.orgCode;
        data["siteId"] = this.siteId;
        data["siteName"] = this.siteName;
        data["dataSource"] = this.dataSource;
        data["mrn"] = this.mrn;
        data["patientName"] = this.patientName;
        data["patientFirstName"] = this.patientFirstName;
        data["patientLastName"] = this.patientLastName;
        data["patientBirthDate"] = this.patientBirthDate;
        data["urgency"] = this.urgency;
        data["traumaProtocol"] = this.traumaProtocol;
        data["strokeProtocolType"] = this.strokeProtocolType;
        data["status"] = this.status;
        data["studyDateTime"] = this.studyDateTime;
        data["modality"] = this.modality;
        data["studyDescription"] = this.studyDescription;
        data["signedAt"] = this.signedAt;
        data["createdAt"] = this.createdAt;
        data["hasAssignedTo"] = this.hasAssignedTo;
        data["lastUpdatedAt"] = this.lastUpdatedAt;
        data["noOfImagesExpected"] = this.noOfImagesExpected;
        data["noOfImagesArrived"] = this.noOfImagesArrived;
        data["referringDoctor"] = this.referringDoctor;
        data["referringDoctorPhone"] = this.referringDoctorPhone;
        data["patientLocation"] = this.patientLocation;
        data["onHold"] = this.onHold;
        data["onHoldUpdatedAt"] = this.onHoldUpdatedAt;
        data["linkedReferralInformation"] = this.linkedReferralInformation ? this.linkedReferralInformation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorklistItemDto {
    id?: string | undefined;
    accessionNumber?: string | undefined;
    orgCode?: string;
    siteId?: number | undefined;
    siteName?: string | undefined;
    dataSource?: WorklistItemDataSourceType;
    mrn?: string | undefined;
    patientName?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientBirthDate?: string | undefined;
    urgency?: UrgencyType | undefined;
    traumaProtocol?: boolean | undefined;
    strokeProtocolType?: StrokeProtocol | undefined;
    status?: StatusType | undefined;
    studyDateTime?: string | undefined;
    modality?: string | undefined;
    studyDescription?: string | undefined;
    signedAt?: string | undefined;
    createdAt?: string | undefined;
    hasAssignedTo?: boolean | undefined;
    lastUpdatedAt?: string | undefined;
    noOfImagesExpected?: number | undefined;
    noOfImagesArrived?: number | undefined;
    referringDoctor?: string | undefined;
    referringDoctorPhone?: string | undefined;
    patientLocation?: string | undefined;
    onHold?: boolean | undefined;
    onHoldUpdatedAt?: string | undefined;
    linkedReferralInformation?: GetLinkedReferralInformation | undefined;
}

export enum WorklistItemDataSourceType {
    Order = "order",
    UnlinkedOrder = "unlinked-order",
}

export enum StatusType {
    AwaitingFurtherDetails = "AwaitingFurtherDetails",
    AwaitingImages = "AwaitingImages",
    TransferringImages = "TransferringImages",
    ReadyToReport = "ReadyToReport",
    Reporting = "Reporting",
    Reported = "Reported",
    Cancelled = "Cancelled",
    OnHoldMissingClinicalHistory = "OnHoldMissingClinicalHistory",
    OnHoldMissingImages = "OnHoldMissingImages",
    OnHoldMissingDocumentation = "OnHoldMissingDocumentation",
    OnHoldMissingPriors = "OnHoldMissingPriors",
    OnHoldMissingPriorImages = "OnHoldMissingPriorImages",
    OnHoldReviewOrderDetails = "OnHoldReviewOrderDetails",
}

export class GetLinkedReferralInformation implements IGetLinkedReferralInformation {
    referralId?: number | undefined;
    isDirectToScan?: boolean;

    constructor(data?: IGetLinkedReferralInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referralId = _data["referralId"];
            this.isDirectToScan = _data["isDirectToScan"];
        }
    }

    static fromJS(data: any): GetLinkedReferralInformation {
        data = typeof data === 'object' ? data : {};
        let result = new GetLinkedReferralInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referralId"] = this.referralId;
        data["isDirectToScan"] = this.isDirectToScan;
        return data;
    }
}

export interface IGetLinkedReferralInformation {
    referralId?: number | undefined;
    isDirectToScan?: boolean;
}

export class WorklistItemDetailsDto extends WorklistItemDto implements IWorklistItemDetailsDto {
    protocol?: string | undefined;
    radiographerName?: string | undefined;
    radiographerNotes?: string | undefined;
    scans?: ScanDto[] | undefined;
    priors?: PriorDto[] | undefined;
    reportText?: string | undefined;
    hasActiveAddenda?: boolean;
    scannedDocuments?: ScannedDocument[] | undefined;
    country?: string | undefined;

    constructor(data?: IWorklistItemDetailsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.protocol = _data["protocol"];
            this.radiographerName = _data["radiographerName"];
            this.radiographerNotes = _data["radiographerNotes"];
            if (Array.isArray(_data["scans"])) {
                this.scans = [] as any;
                for (let item of _data["scans"])
                    this.scans!.push(ScanDto.fromJS(item));
            }
            if (Array.isArray(_data["priors"])) {
                this.priors = [] as any;
                for (let item of _data["priors"])
                    this.priors!.push(PriorDto.fromJS(item));
            }
            this.reportText = _data["reportText"];
            this.hasActiveAddenda = _data["hasActiveAddenda"];
            if (Array.isArray(_data["scannedDocuments"])) {
                this.scannedDocuments = [] as any;
                for (let item of _data["scannedDocuments"])
                    this.scannedDocuments!.push(ScannedDocument.fromJS(item));
            }
            this.country = _data["country"];
        }
    }

    static override fromJS(data: any): WorklistItemDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorklistItemDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["protocol"] = this.protocol;
        data["radiographerName"] = this.radiographerName;
        data["radiographerNotes"] = this.radiographerNotes;
        if (Array.isArray(this.scans)) {
            data["scans"] = [];
            for (let item of this.scans)
                data["scans"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.priors)) {
            data["priors"] = [];
            for (let item of this.priors)
                data["priors"].push(item ? item.toJSON() : <any>undefined);
        }
        data["reportText"] = this.reportText;
        data["hasActiveAddenda"] = this.hasActiveAddenda;
        if (Array.isArray(this.scannedDocuments)) {
            data["scannedDocuments"] = [];
            for (let item of this.scannedDocuments)
                data["scannedDocuments"].push(item ? item.toJSON() : <any>undefined);
        }
        data["country"] = this.country;
        super.toJSON(data);
        return data;
    }
}

export interface IWorklistItemDetailsDto extends IWorklistItemDto {
    protocol?: string | undefined;
    radiographerName?: string | undefined;
    radiographerNotes?: string | undefined;
    scans?: ScanDto[] | undefined;
    priors?: PriorDto[] | undefined;
    reportText?: string | undefined;
    hasActiveAddenda?: boolean;
    scannedDocuments?: ScannedDocument[] | undefined;
    country?: string | undefined;
}

export class ScanDto implements IScanDto {
    id?: number | undefined;
    modality?: string | undefined;
    studyDescription?: string | undefined;
    noOfImagesArrived?: number | undefined;
    expectedImageCount?: number | undefined;
    accessionNumber?: string | undefined;

    constructor(data?: IScanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modality = _data["modality"];
            this.studyDescription = _data["studyDescription"];
            this.noOfImagesArrived = _data["noOfImagesArrived"];
            this.expectedImageCount = _data["expectedImageCount"];
            this.accessionNumber = _data["accessionNumber"];
        }
    }

    static fromJS(data: any): ScanDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modality"] = this.modality;
        data["studyDescription"] = this.studyDescription;
        data["noOfImagesArrived"] = this.noOfImagesArrived;
        data["expectedImageCount"] = this.expectedImageCount;
        data["accessionNumber"] = this.accessionNumber;
        return data;
    }
}

export interface IScanDto {
    id?: number | undefined;
    modality?: string | undefined;
    studyDescription?: string | undefined;
    noOfImagesArrived?: number | undefined;
    expectedImageCount?: number | undefined;
    accessionNumber?: string | undefined;
}

export class PriorDto implements IPriorDto {
    priorId?: number;
    modality?: string | undefined;
    studyDescription?: string | undefined;
    studyDate?: string | undefined;
    accessionNumber?: string | undefined;

    constructor(data?: IPriorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priorId = _data["priorId"];
            this.modality = _data["modality"];
            this.studyDescription = _data["studyDescription"];
            this.studyDate = _data["studyDate"];
            this.accessionNumber = _data["accessionNumber"];
        }
    }

    static fromJS(data: any): PriorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priorId"] = this.priorId;
        data["modality"] = this.modality;
        data["studyDescription"] = this.studyDescription;
        data["studyDate"] = this.studyDate;
        data["accessionNumber"] = this.accessionNumber;
        return data;
    }
}

export interface IPriorDto {
    priorId?: number;
    modality?: string | undefined;
    studyDescription?: string | undefined;
    studyDate?: string | undefined;
    accessionNumber?: string | undefined;
}

export class ScannedDocument implements IScannedDocument {
    name?: string;
    originalFileName?: string | undefined;

    constructor(data?: IScannedDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.originalFileName = _data["originalFileName"];
        }
    }

    static fromJS(data: any): ScannedDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ScannedDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["originalFileName"] = this.originalFileName;
        return data;
    }
}

export interface IScannedDocument {
    name?: string;
    originalFileName?: string | undefined;
}

export class PatchOrderRequest implements IPatchOrderRequest {
    updateCallTime?: boolean;
    radiographerName?: string | undefined;
    notes?: string | undefined;
    patientLocation?: string | undefined;
    radiographerNotes?: string | undefined;
    referringDoctor?: string | undefined;
    referringDoctorPhoneNo?: string | undefined;
    urgency?: UrgencyType | undefined;
    traumaProtocol?: boolean | undefined;
    strokeProtocolType?: StrokeProtocol | undefined;
    requestingUserDisplayName?: string | undefined;

    constructor(data?: IPatchOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateCallTime = _data["updateCallTime"];
            this.radiographerName = _data["radiographerName"];
            this.notes = _data["notes"];
            this.patientLocation = _data["patientLocation"];
            this.radiographerNotes = _data["radiographerNotes"];
            this.referringDoctor = _data["referringDoctor"];
            this.referringDoctorPhoneNo = _data["referringDoctorPhoneNo"];
            this.urgency = _data["urgency"];
            this.traumaProtocol = _data["traumaProtocol"];
            this.strokeProtocolType = _data["strokeProtocolType"];
            this.requestingUserDisplayName = _data["requestingUserDisplayName"];
        }
    }

    static fromJS(data: any): PatchOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PatchOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateCallTime"] = this.updateCallTime;
        data["radiographerName"] = this.radiographerName;
        data["notes"] = this.notes;
        data["patientLocation"] = this.patientLocation;
        data["radiographerNotes"] = this.radiographerNotes;
        data["referringDoctor"] = this.referringDoctor;
        data["referringDoctorPhoneNo"] = this.referringDoctorPhoneNo;
        data["urgency"] = this.urgency;
        data["traumaProtocol"] = this.traumaProtocol;
        data["strokeProtocolType"] = this.strokeProtocolType;
        data["requestingUserDisplayName"] = this.requestingUserDisplayName;
        return data;
    }
}

export interface IPatchOrderRequest {
    updateCallTime?: boolean;
    radiographerName?: string | undefined;
    notes?: string | undefined;
    patientLocation?: string | undefined;
    radiographerNotes?: string | undefined;
    referringDoctor?: string | undefined;
    referringDoctorPhoneNo?: string | undefined;
    urgency?: UrgencyType | undefined;
    traumaProtocol?: boolean | undefined;
    strokeProtocolType?: StrokeProtocol | undefined;
    requestingUserDisplayName?: string | undefined;
}

export class PatchProcedureRequest implements IPatchProcedureRequest {
    expectedImageCount?: number | undefined;
    radiographerName?: string | undefined;

    constructor(data?: IPatchProcedureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expectedImageCount = _data["expectedImageCount"];
            this.radiographerName = _data["radiographerName"];
        }
    }

    static fromJS(data: any): PatchProcedureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PatchProcedureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectedImageCount"] = this.expectedImageCount;
        data["radiographerName"] = this.radiographerName;
        return data;
    }
}

export interface IPatchProcedureRequest {
    expectedImageCount?: number | undefined;
    radiographerName?: string | undefined;
}

export class PostPriorRequest implements IPostPriorRequest {
    modality?: string | undefined;
    studyDescription?: string | undefined;
    accessionNumber?: string | undefined;
    priorDate?: string | undefined;
    radiographerName?: string | undefined;

    constructor(data?: IPostPriorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modality = _data["modality"];
            this.studyDescription = _data["studyDescription"];
            this.accessionNumber = _data["accessionNumber"];
            this.priorDate = _data["priorDate"];
            this.radiographerName = _data["radiographerName"];
        }
    }

    static fromJS(data: any): PostPriorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostPriorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modality"] = this.modality;
        data["studyDescription"] = this.studyDescription;
        data["accessionNumber"] = this.accessionNumber;
        data["priorDate"] = this.priorDate;
        data["radiographerName"] = this.radiographerName;
        return data;
    }
}

export interface IPostPriorRequest {
    modality?: string | undefined;
    studyDescription?: string | undefined;
    accessionNumber?: string | undefined;
    priorDate?: string | undefined;
    radiographerName?: string | undefined;
}

export class PatchPriorRequest implements IPatchPriorRequest {
    modality?: string | undefined;
    studyDescription?: string | undefined;
    accessionNumber?: string | undefined;
    priorDate?: string | undefined;
    radiographerName?: string | undefined;

    constructor(data?: IPatchPriorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modality = _data["modality"];
            this.studyDescription = _data["studyDescription"];
            this.accessionNumber = _data["accessionNumber"];
            this.priorDate = _data["priorDate"];
            this.radiographerName = _data["radiographerName"];
        }
    }

    static fromJS(data: any): PatchPriorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PatchPriorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modality"] = this.modality;
        data["studyDescription"] = this.studyDescription;
        data["accessionNumber"] = this.accessionNumber;
        data["priorDate"] = this.priorDate;
        data["radiographerName"] = this.radiographerName;
        return data;
    }
}

export interface IPatchPriorRequest {
    modality?: string | undefined;
    studyDescription?: string | undefined;
    accessionNumber?: string | undefined;
    priorDate?: string | undefined;
    radiographerName?: string | undefined;
}

export class UpsertNotification implements IUpsertNotification {
    updatedEntityType?: EntityType;
    baseEntityType?: EntityType;
    updatedEntityDetails?: any;
    operation?: Operation;
    orgCode?: string | undefined;
    siteId?: number | undefined;

    constructor(data?: IUpsertNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedEntityType = _data["updatedEntityType"];
            this.baseEntityType = _data["baseEntityType"];
            this.updatedEntityDetails = _data["updatedEntityDetails"];
            this.operation = _data["operation"];
            this.orgCode = _data["orgCode"];
            this.siteId = _data["siteId"];
        }
    }

    static fromJS(data: any): UpsertNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedEntityType"] = this.updatedEntityType;
        data["baseEntityType"] = this.baseEntityType;
        data["updatedEntityDetails"] = this.updatedEntityDetails;
        data["operation"] = this.operation;
        data["orgCode"] = this.orgCode;
        data["siteId"] = this.siteId;
        return data;
    }
}

export interface IUpsertNotification {
    updatedEntityType?: EntityType;
    baseEntityType?: EntityType;
    updatedEntityDetails?: any;
    operation?: Operation;
    orgCode?: string | undefined;
    siteId?: number | undefined;
}

export enum EntityType {
    None = "None",
    Decision = "Decision",
    DecisionItem = "DecisionItem",
    LinkedOrder = "LinkedOrder",
    Order = "Order",
    Patient = "Patient",
    Prior = "Prior",
    Procedure = "Procedure",
    Referral = "Referral",
    ReferralItem = "ReferralItem",
    UnlinkedOrder = "UnlinkedOrder",
    UnlinkedOrderItem = "UnlinkedOrderItem",
    TelepatientRetrieval = "TelepatientRetrieval",
    TelepatientRecord = "TelepatientRecord",
    ClinicalDiscussion = "ClinicalDiscussion",
}

export enum Operation {
    Unknown = "Unknown",
    Insert = "Insert",
    Update = "Update",
    Delete = "Delete",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}